// Central content for Sharma Model Aero Engines & Propellers

export const COMPANY = {
  name: "Sharma Model Aero Engines & Propellers",
  shortName: "Sharma Model Aero",
  tagline: "Fifty-Two Years of Powering Indian Aeromodelling Dreams",
  established: 1974,
  location: "Jodhpur, Rajasthan",
  address: "Jodhpur, Rajasthan – 342001, India",
  email: "info@sharmamodelaero.com",
  website: "www.sharmamodelaero.com",
};

export const IMAGES = {
  hero: "/hero.jpeg",
  cnc: "https://images.unsplash.com/photo-1711418235334-8895331a6cf9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxhZXJvc3BhY2UlMjBtYW51ZmFjdHVyaW5nJTIwQ05DfGVufDB8fHx8MTc4NTQwOTM4MHww&ixlib=rb-4.1.0&q=85",
  vintage: "https://images.unsplash.com/photo-1774901091172-a97e0e4a2c2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwbW9kZWwlMjBhaXJwbGFuZXxlbnwwfHx8fDE3ODU0MDkzODB8MA&ixlib=rb-4.1.0&q=85",
  drone: "https://images.unsplash.com/photo-1508444845599-5c89863b1c44?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxkcm9uZSUyMGZsaWdodCUyMGF2aWF0aW9ufGVufDB8fHx8MTc4NTQwOTM4MXww&ixlib=rb-4.1.0&q=85",
};

export const NAV = [
  { label: "About Us", to: "/about" },
  { label: "Products & Services", to: "/products" },
  { label: "Gallery", to: "/gallery" },
  { label: "Blog", to: "/blog" },
  { label: "Contact Us", to: "/contact" },
];

export const HERO = {
  overline: "Est. 1974",
  headlineLines: ["From a Child's First Flight", "to a Nation's Defence,", "Quality, Precision & Performance", "— A Tradition Since 1974"],
  intro:
    "Since 1974, Sharma Model Aero Engines & Propellers has been Indian trusted name for nation's aeromodelling dreams — building engines, propellers, and aircraft indigenously, for Indian skies. From training the country's first NCC aeromodellers to designing Made in India Remotely Piloted Aircraft for Indian defence forces, our engineering has never stopped evolving. Today, three generations and 140+ years of combined experience stand behind every product we build.",
};

export const TRUST = {
  banners: [
    "Trusted by Indian Defence Forces Since 1998",
    "Serving Aeromodellers & Air Wing NCC Units Since 1974",
  ],
  lines: [
    "The only company in India to have continuously served Indian aeromodellers and Air Wing NCC units for over 52 years.",
    "Indigenously designed Remotely Piloted Aircraft and UAS solutions trusted by Indian defence training programs for nearly three decades.",
    "A family legacy of over 140 years of combined engineering experience, built through patience, precision, and passion.",
  ],
};

export const STATS = [
  { value: 1974, suffix: "", label: "Year Founded", prefix: "" },
  { value: 52, suffix: "+", label: "Years Serving Aeromodellers & NCC", prefix: "" },
  { value: 28, suffix: "+", label: "Years Serving Indian Defence Forces", prefix: "" },
  { value: 140, suffix: "+", label: "Years Combined Family Experience", prefix: "" },
  { value: 4.4, suffix: " / 5", label: "Verified Rating on Justdial", prefix: "", decimals: 1 },
  { value: 100, suffix: "%", label: "Made in India — Indigenously Built", prefix: "" },
];

export const PRODUCTS = [
  {
    id: "engines",
    icon: "Cog",
    title: "Model Aero Engines",
    blurb: "Precision two-stroke and diesel engines with highly experienced craftsmanship using modern CNC machining technology.",
    bg: "/products/engines.jpg",
  },
  {
    id: "propellers",
    icon: "Fan",
    title: "Propellers",
    blurb: "Precision propellers of various types and size, built in-house to the highest quality standards.",
    bg: "/products/propellers.webp",
  },
  {
    id: "kits",
    icon: "Plane",
    title: "RC & Control-Line Model Kits",
    blurb: "Complete radio-control and control-line kits engineered for reliable flight — trusted in NCC training.",
    bg: "/products/kits.png",
  },
  {
    id: "diy",
    icon: "Wrench",
    title: "DIY Glider & Building Kits",
    blurb: "Entry-level gliders and building accessories that start young aeromodellers on a lifelong journey into the skies.",
    bg: "/products/diy.webp",
  },
  {
    id: "rpas",
    icon: "Radar",
    title: "Defense-Grade RPAS",
    blurb: "Indigenously designed Remotely Piloted Aircraft supporting Indian defence training programs since 1998.",
    bg: "/products/rpas.jpeg",
  },
  {
    id: "uas",
    icon: "Satellite",
    title: "Custom UAS Solutions",
    blurb: "Bespoke unmanned aerial systems and integration, engineered to mission requirements with distributed third-party platforms.",
    bg: "/products/uas.jpeg",
  },
];

export const PRODUCT_CATEGORIES = [
  {
    id: "engines",
    title: "Model Engines",
    image: IMAGES.vintage,
    description:
      "Our flagship line of model aero engines — from compact glow motors to high-torque units — each assembled and run-in by hand, then bench-tested for reliability. Decades on, hobbyists still report Sharma engines from the early 1980s running strong.",
    items: ["Glow engines (0.049 – 0.61 cu in class)", "Diesel & compression-ignition engines", "Bench-tested & run-in units", "Spares, glow plugs & tuned pipes"],
  },
  {
    id: "propellers",
    title: "Propellers",
    image: IMAGES.drone,
    description:
      "CNC-cut and balanced propellers in wood and composite. Consistent geometry means predictable thrust — a favourite for trainers, sport and scale aircraft alike.",
    items: ["Beechwood & maple propellers", "Glass / carbon composite propellers", "Trainer, sport & scale profiles", "Custom diameters & pitches on request"],
  },
  {
    id: "kits",
    title: "Model Kits — Glider · Control-Line · RC",
    image: IMAGES.vintage,
    description:
      "Complete flying kits engineered for repeatable building and dependable flight. Used across clubs and Air Wing NCC units nationwide for hands-on aeromodelling training.",
    items: ["Radio-control trainer & sport kits", "Control-line stunt & speed kits", "Chuck & catapult glider kits", "Full hardware & plans included"],
  },
  {
    id: "diy",
    title: "Building Accessories & DIY Kits",
    image: IMAGES.cnc,
    description:
      "Everything a builder needs — from balsa and ply to covering film, adhesives and control linkages — plus beginner-friendly DIY glider kits to spark the next generation of flyers.",
    items: ["Balsa, ply & spruce building stock", "Covering film, adhesives & hardware", "Undercarriage, wheels & linkages", "Beginner DIY glider building kits"],
  },
  {
    id: "rpas",
    title: "Defense RPAS & Custom UAS Solutions",
    image: IMAGES.hero,
    description:
      "Since 1998, we have indigenously designed Remotely Piloted Aircraft and unmanned aerial systems trusted by Indian defence training programs. Every platform is engineered, built and supported in India.",
    items: ["Fixed-wing RPAS for training", "Custom UAS to mission spec", "Airframe design & composite fabrication", "Field support & spares"],
  },
  {
    id: "distributed",
    title: "Distributed Third-Party UAS Products",
    image: IMAGES.drone,
    description:
      "Alongside our own manufacturing, we distribute carefully selected third-party UAS products and components — extending a complete, dependable supply chain to our defence and institutional customers.",
    items: ["Curated third-party UAS platforms", "Ground-control & payload components", "Integration & advisory", "Institutional procurement support"],
  },
];

export const MANUFACTURING = {
  heading: "From Craftsman's Hands to Computer-Aided Precision",
  intro:
    "Half a century of craft, sharpened by modern engineering. Our Jodhpur facility marries the hand-skills of a legacy workshop with the repeatability of computer-controlled production.",
  chapters: [
    { no: "01", title: "In-House CNC Machining", body: "Precision machining of both wood and metal on in-house CNC." },
    { no: "02", title: "Computer-Aided Design", body: "Every airframe and component is modelled in CAD before a single cut, so tolerances are held and iterations are fast." },
    { no: "03", title: "Composite Fabrication", body: "Vacuum-bagged composite fabrication in glass and carbon fibre for light, strong structures built to fly and to last." },
  ],
};

export const COMMUNITY = {
  heading: "Built With The Aeromodelling Community",
  body:
    "In partnership with the Aeromodellers' Association India (AMAI), we support and organize flying shows, hands-on workshops, and competitions across the country — nurturing the clubs, students and Air Wing NCC cadets who keep Indian aeromodelling alive.",
  points: ["Nationwide shows & flying meets", "Hands-on building workshops", "Club & inter-school competitions"],
};

export const TESTIMONIALS = [
  {
    quote: "My Sharma glow engine from the early 1980s still fires up on the first few flicks. Four decades of flying on the same motor.",
    author: "Long-time RC Hobbyist",
    meta: "Aeromodeller since 1982",
  },
  {
    quote: "Dependable engines and honest service. The kits we use for our NCC cadets are built to survive real training.",
    author: "Air Wing Instructor",
    meta: "NCC Aeromodelling Programme",
  },
  {
    quote: "Consistent quality and a genuine understanding of what flyers need. A rare, trusted name in Indian aeromodelling.",
    author: "Verified Buyer",
    meta: "Justdial · 4.4 / 5",
  },
];

export const RECOGNITION = [
  { label: "Justdial Rating", value: "4.4 / 5", note: "Verified customer reviews" },
  { label: "Justdial", value: "Listed", note: "Trusted local manufacturer" },
  { label: "Since", value: "1974", note: "52 years of continuous service" },
];

export const GALLERY = [
  { src: IMAGES.hero, span: "lg", caption: "Indigenous RPAS in flight" },
  { src: IMAGES.vintage, span: "sm", caption: "Heritage model, restored" },
  { src: IMAGES.cnc, span: "sm", caption: "In-house CNC machining" },
  { src: IMAGES.drone, span: "md", caption: "UAS field demonstration" },
  { src: IMAGES.cnc, span: "md", caption: "Composite fabrication bay" },
  { src: IMAGES.vintage, span: "sm", caption: "Control-line model kit" },
  { src: IMAGES.drone, span: "sm", caption: "Custom UAS build" },
  { src: IMAGES.hero, span: "lg", caption: "NCC training demonstration" },
];

export const BLOG_POSTS = [
  {
    id: "tuning-glow-engines",
    title: "Tuning Your First Glow Engine: A Beginner's Field Guide",
    excerpt: "From needle-valve settings to break-in runs — the essentials every new aeromodeller should know before that first flight.",
    date: "2025-11-18",
    category: "Aeromodelling Tips",
    image: IMAGES.vintage,
    readTime: "6 min read",
  },
  {
    id: "ncc-air-wing-2025",
    title: "Inside an Air Wing NCC Aeromodelling Camp",
    excerpt: "A look at how cadets go from balsa sheets to airborne trainers in a single week-long camp — and the kits that make it possible.",
    date: "2025-10-02",
    category: "NCC Events",
    image: IMAGES.hero,
    readTime: "5 min read",
  },
  {
    id: "rpas-milestone",
    title: "Twenty-Seven Years of Indigenous RPAS",
    excerpt: "Reflecting on the journey from our first defence RPAS in 1998 to today's custom UAS platforms — engineered entirely in India.",
    date: "2025-08-14",
    category: "Defense Projects",
    image: IMAGES.drone,
    readTime: "7 min read",
  },
  {
    id: "aai-workshop-jaipur",
    title: "Recap: AMAI Building Workshop in Jaipur",
    excerpt: "Highlights from our latest workshop with the Aeromodellers' Association India — new builders, new gliders, plenty of flying.",
    date: "2025-06-27",
    category: "Workshops",
    image: IMAGES.cnc,
    readTime: "4 min read",
  },
  {
    id: "composite-props",
    title: "Why We Cut Our Own Propellers",
    excerpt: "The case for CNC-balanced propellers, and how in-house manufacturing keeps thrust consistent across every unit we ship.",
    date: "2025-05-09",
    category: "Aeromodelling Tips",
    image: IMAGES.cnc,
    readTime: "5 min read",
  },
  {
    id: "engines-that-last",
    title: "Engines That Outlast Decades",
    excerpt: "Hobbyists still fly Sharma engines from the early 1980s. Here's the engineering philosophy behind that longevity.",
    date: "2025-03-21",
    category: "Heritage",
    image: IMAGES.vintage,
    readTime: "6 min read",
  },
];

export const ABOUT_SECTIONS = [
  {
    no: "01",
    title: "Our Origins",
    body: "In 1974, in a modest Jodhpur workshop, Mr. Anand Swaroop Sharma, supported by his Late brother Mr. Mahesh Kumar began with a single machine and a stubborn conviction — that India could design and build its own aeromodelling engines. It was a nation's aeromodelling dream, taken up by Indian hands.",
  },
  {
    no: "02",
    title: "Growth, One Engine at a Time",
    body: "What started with one machine grew, patiently, into a full manufacturing operation. As demand grew from clubs, schools and the country's first NCC aeromodellers, so did our capability — engines, propellers and complete flying kits, all made in Jodhpur.",
  },
  {
    no: "03",
    title: "Precision Manufacturing",
    body: "From a craftsman's hands to computer-aided precision. Today our facility combines in-house CNC machining of wood and metal, computer-aided design, and vacuum-bagged composite fabrication in glass and carbon fibre — legacy craft, sharpened by modern engineering.",
  },
  {
    no: "04",
    title: "Serving Indian Defence Forces",
    body: "In 1998 we expanded into indigenously designed Remotely Piloted Aircraft and UAS solutions. For nearly three decades our platforms have been trusted by Indian defence training programs, alongside a distribution line of carefully selected third-party UAS products.",
  },
  {
    no: "05",
    title: "A Family Legacy of 140+ Years",
    body: "Three generations now stand behind the workbench, with over 140 years of combined engineering experience between them. We remain the only company in India to have continuously served Indian aeromodellers and Air Wing NCC units for over 52 years.",
  },
  {
    no: "06",
    title: "Community & Recognition",
    body: "In partnership with the Aeromodellers' Association India (AMAI) (www.amai.in) we support shows, workshops and competitions nationwide. Our work is independently recognised — a 4.1/5 rating on IndiaMART, a trusted Justdial listing, and hobbyists whose Sharma engines still run decades on.",
  },
];

export const MARQUEE_WORDS = [
  "EST. 1974",
  "MADE IN INDIA",
  "TRUSTED BY DEFENCE",
  "JODHPUR · RAJASTHAN",
  "52 YEARS OF FLIGHT",
  "AIR WING NCC",
];

// ---------------- Product Catalogue ----------------
// Filter categories (order matters). "All" is prepended in the UI.
export const CATALOG_CATEGORIES = [
  "Model Engines",
  "Glow Plug Engines",
  "Petrol/Gas Engines",
  "Diesel Engines",
  "Engine Accessories",
  "Propellers",
  "Brushless Motors & ESCs",
  "Servo Motors",
  "Model Kits",
  "RC ARF Models",
  "Seagull ARF Models",
  "FMS PNP Models",
  "3D Aerobatic Models",
  "Chuck & Catapult Gliders",
  "Control Line Kits",
  "Display Model Kits",
  "R/C Systems",
  "Balsa & Depron",
  "Flight Simulators",
  "Building Accessories",
  "Defense RPAS & UAS",
  "Distributed UAS",
];

export const CATALOG = [
  // ---- Model Engines ----
  {
    id: "sma-glow-15",
    name: "SMA Glow .15",
    category: "Model Engines",
    image: IMAGES.vintage,
    tagline: "Compact 2.5cc glow engine for trainers & sport flyers.",
    description:
      "A dependable entry-class glow engine, hand-assembled and bench run-in before it leaves the workshop. Smooth idle and a wide usable RPM band make it a proven first engine for clubs and NCC cadets.",
    specs: [
      { label: "Displacement", value: "2.5 cc (0.15 cu in)" },
      { label: "Bore × Stroke", value: "15.0 × 14.2 mm" },
      { label: "RPM Range", value: "2,500 – 16,000" },
      { label: "Weight", value: "145 g" },
      { label: "Fuel", value: "Glow — methanol / nitro" },
      { label: "Cooling", value: "Air-cooled" },
    ],
  },
  {
    id: "sma-glow-25",
    name: "SMA Sport .25",
    category: "Model Engines",
    image: IMAGES.vintage,
    tagline: "Versatile 4.1cc glow engine with strong mid-range torque.",
    description:
      "The workhorse of the range. Balanced for sport and scale models needing reliable power without fuss, with easy needle-valve tuning for field conditions.",
    specs: [
      { label: "Displacement", value: "4.1 cc (0.25 cu in)" },
      { label: "Bore × Stroke", value: "17.5 × 17.0 mm" },
      { label: "RPM Range", value: "2,200 – 15,000" },
      { label: "Weight", value: "210 g" },
      { label: "Prop Range", value: "9×6 – 10×6" },
      { label: "Cooling", value: "Air-cooled" },
    ],
  },
  {
    id: "sma-abc-40",
    name: "SMA ABC .40",
    category: "Model Engines",
    image: IMAGES.vintage,
    tagline: "High-output 6.5cc ABC glow engine for aerobatic models.",
    description:
      "An ABC (aluminium/brass/chrome) piston-liner set delivers crisp throttle response and long service life for aerobatic and larger sport aircraft.",
    specs: [
      { label: "Displacement", value: "6.5 cc (0.40 cu in)" },
      { label: "Bore × Stroke", value: "21.0 × 19.0 mm" },
      { label: "RPM Range", value: "2,000 – 16,500" },
      { label: "Weight", value: "315 g" },
      { label: "Prop Range", value: "10×6 – 11×7" },
      { label: "Piston/Liner", value: "ABC" },
    ],
  },
  {
    id: "sma-diesel-18",
    name: "SMA Diesel .18",
    category: "Model Engines",
    image: IMAGES.vintage,
    tagline: "Classic 3.0cc compression-ignition diesel engine.",
    description:
      "A traditional compression-ignition diesel prized for its torque and glow-plug-free simplicity — a favourite for control-line and vintage builds.",
    specs: [
      { label: "Displacement", value: "3.0 cc (0.18 cu in)" },
      { label: "Ignition", value: "Compression (diesel)" },
      { label: "RPM Range", value: "2,000 – 14,000" },
      { label: "Weight", value: "175 g" },
      { label: "Fuel", value: "Ether / kerosene / oil mix" },
      { label: "Best For", value: "Control-line, vintage" },
    ],
  },
  // ---- Propellers ----
  {
    id: "prop-beech-10x6",
    name: "Beechwood Propeller 10×6",
    category: "Propellers",
    image: IMAGES.drone,
    tagline: "Hand-finished, CNC-balanced beechwood propeller.",
    description:
      "Cut on in-house CNC and hand-finished for a true running balance. Warm, efficient thrust for .25–.40 class trainers and sport models.",
    specs: [
      { label: "Diameter", value: "10 in (254 mm)" },
      { label: "Pitch", value: "6 in" },
      { label: "Material", value: "Seasoned beechwood" },
      { label: "Hub Bore", value: "6 mm (reducers incl.)" },
      { label: "Balance", value: "CNC + hand-balanced" },
    ],
  },
  {
    id: "prop-maple-11x7",
    name: "Maple Sport Propeller 11×7",
    category: "Propellers",
    image: IMAGES.drone,
    tagline: "Higher-pitch maple prop for faster sport airframes.",
    description:
      "A denser maple blade holding pitch under load — ideal for sport models that want more speed from a .40-class engine.",
    specs: [
      { label: "Diameter", value: "11 in (279 mm)" },
      { label: "Pitch", value: "7 in" },
      { label: "Material", value: "Hard maple" },
      { label: "Hub Bore", value: "8 mm (reducers incl.)" },
      { label: "Balance", value: "CNC + hand-balanced" },
    ],
  },
  {
    id: "prop-carbon-12x8",
    name: "Carbon Composite Propeller 12×8",
    category: "Propellers",
    image: IMAGES.cnc,
    tagline: "Vacuum-bagged carbon fibre for stiffness & efficiency.",
    description:
      "Fabricated in carbon fibre using our vacuum-bagging process. Light, rigid and repeatable — for demanding sport and electric applications.",
    specs: [
      { label: "Diameter", value: "12 in (305 mm)" },
      { label: "Pitch", value: "8 in" },
      { label: "Material", value: "Carbon fibre composite" },
      { label: "Hub Bore", value: "8 mm" },
      { label: "Finish", value: "Gloss, moulded" },
    ],
  },
  {
    id: "prop-nylon-9x5",
    name: "Glass-Filled Nylon Propeller 9×5",
    category: "Propellers",
    image: IMAGES.drone,
    tagline: "Tough, everyday trainer propeller that shrugs off knocks.",
    description:
      "Glass-filled nylon gives forgiving durability for training fields where a nose-over is part of the learning curve.",
    specs: [
      { label: "Diameter", value: "9 in (229 mm)" },
      { label: "Pitch", value: "5 in" },
      { label: "Material", value: "Glass-filled nylon" },
      { label: "Hub Bore", value: "6 mm" },
      { label: "Best For", value: "Trainers / beginners" },
    ],
  },
  // ---- Model Kits ----
  {
    id: "kit-wicked-slick-pro-blue",
    name: "33\" Wicked Slick Pro — PNP Combo (Blue & Yellow)",
    category: "Model Kits",
    image: "/products/WICKED-SLICKED-PRO-3-1.webp",
    tagline: "One of the most elegant 3D aerobatic airframes to grace a flying field.",
    description:
      "The Wicked Slick Pro is a stunning 3D aerobatic model built for indoor and outdoor precision flight. Robust EPP foam construction with an eye-catching blue & yellow scheme, carbon-reinforced wings, fuselage and suspension mounts, plus a generous hardware package.",
    specs: [
      { label: "Type", value: "3D Aerobatic RC" },
      { label: "Wingspan", value: "33 in (838 mm)" },
      { label: "Configuration", value: "PNP Combo" },
      { label: "Scheme", value: "Blue & Yellow" },
      { label: "Construction", value: "EPP foam, carbon reinforced" },
      { label: "Skill Level", value: "Intermediate – Advanced" },
    ],
  },
  {
    id: "kit-wicked-slick-pro-red",
    name: "33\" Wicked Slick Pro — PNP Combo (Red & Yellow)",
    category: "Model Kits",
    image: "/products/37-WICKED-SLICK-PRO-2-1.webp",
    tagline: "The same elegant 3D airframe in a striking red & yellow livery.",
    description:
      "A 3D aerobatic model in Red & Yellow trim — enhanced 3D aerobatic performance with robust EPP foam construction, carbon-reinforced braces for wings, fuselage and suspension mounts, and a complete hardware package for indoor and outdoor 3D manoeuvres.",
    specs: [
      { label: "Type", value: "3D Aerobatic RC" },
      { label: "Wingspan", value: "33 in (838 mm)" },
      { label: "Configuration", value: "PNP Combo" },
      { label: "Scheme", value: "Red & Yellow" },
      { label: "Construction", value: "EPP foam, carbon reinforced" },
      { label: "Skill Level", value: "Intermediate – Advanced" },
    ],
  },
  {
    id: "kit-daffy-duck",
    name: "Daffy Duck RC Kit",
    category: "Model Kits",
    image: "/products/daffy-duck.jpg",
    tagline: "CNC laser-cut electric RC kit — very easy to build.",
    description:
      "Contains CNC laser-cut parts with a full-scale building drawing. Very easy to build. Requires assembly, brushless electric motor, ESC, servos, 4-channel radio & receiver, LiPo battery and charger.",
    specs: [
      { label: "Type", value: "Radio Control (Electric)" },
      { label: "Motor (recommended)", value: "2212 · 1400 KV" },
      { label: "ESC", value: "30 A" },
      { label: "Servos", value: "3 × 12 g metal gear" },
      { label: "Battery", value: "LiPo 3S · 11.1 V · 2200 mAh" },
      { label: "Radio", value: "4 Channel" },
      { label: "Propeller", value: "8×4 / 8×6" },
    ],
  },
  {
    id: "kit-easy-40",
    name: "Easy 40 RC Kit",
    category: "Model Kits",
    image: "/products/easy-40.jpg",
    tagline: "Pre-cut wood parts and scaled drawing for a straightforward .40-class build.",
    description:
      "Kit contains pre-cut wood parts and a scaled drawing for building. Requires assembly, engine, propeller, radio-control set with 4 servos and fuel.",
    specs: [
      { label: "Type", value: "Radio Control (Glow)" },
      { label: "Engine Class", value: ".40" },
      { label: "Radio", value: "4 Channel with 4 Servos" },
      { label: "Build", value: "Pre-cut wood, scaled drawing" },
      { label: "Skill Level", value: "Beginner – Intermediate" },
    ],
  },
  {
    id: "kit-kaiser-mkii",
    name: "Kaiser MKII RC Kit",
    category: "Model Kits",
    image: "/products/2016_12_Kaiser-MKII-e1481614899983.jpg",
    tagline: "Versatile glow or electric RC kit with pre-cut wood parts.",
    description:
      "Kit contains pre-cut wood parts and a scaled drawing for building. Requires assembly, engine (or electric motor), propeller, radio-control set with 4 servos, and fuel (or battery for electric).",
    specs: [
      { label: "Type", value: "Radio Control (Glow / Electric)" },
      { label: "Radio", value: "4 Channel with 4 Servos" },
      { label: "Powerplant", value: "Glow engine or brushless motor" },
      { label: "Build", value: "Pre-cut wood, scaled drawing" },
      { label: "Skill Level", value: "Intermediate" },
    ],
  },
  {
    id: "kit-apple-box-glider",
    name: "RC Glider — Apple Box Kit",
    category: "Model Kits",
    image: "/products/Apple-Box-scaled.jpg",
    tagline: "A radio-control glider kit for smooth, thermal-hunting flight.",
    description:
      "The Apple Box RC glider kit — a proven flyer for hobbyists learning graceful, powered-glider handling. Requires assembly, motor / ESC and radio equipment.",
    specs: [
      { label: "Type", value: "Radio Control Glider" },
      { label: "Discipline", value: "Powered glider / thermal soaring" },
      { label: "Radio", value: "4 Channel with 4 Servos" },
      { label: "Skill Level", value: "Intermediate" },
    ],
  },
  {
    id: "kit-swan",
    name: "Swan RC Kit",
    category: "Model Kits",
    image: "/products/swan-scaled.jpg",
    tagline: "Classic RC trainer / sport kit for glow-engine flight.",
    description:
      "The Swan RC kit — a graceful sport airframe. Requires engine, propeller, radio-control set with 4 servos, and fuel.",
    specs: [
      { label: "Type", value: "Radio Control (Glow)" },
      { label: "Radio", value: "4 Channel with 4 Servos" },
      { label: "Powerplant", value: "Glow engine + propeller" },
      { label: "Skill Level", value: "Beginner – Intermediate" },
    ],
  },
  {
    id: "kit-vee-one",
    name: "Vee One RC Kit",
    category: "Model Kits",
    image: "/products/2016_12_VEE-ONE-Top-copy.jpg",
    tagline: "Easy-build electric RC kit with CNC laser-cut parts.",
    description:
      "Contains CNC laser-cut parts with a full-scale building drawing. Very easy to build. Requires assembly, brushless electric motor, ESC, servos, 4-channel radio & receiver, LiPo battery and charger.",
    specs: [
      { label: "Type", value: "Radio Control (Electric)" },
      { label: "Motor (recommended)", value: "2212 · 1400 KV" },
      { label: "ESC", value: "30 A" },
      { label: "Servos", value: "4 × 12 g metal gear" },
      { label: "Battery", value: "LiPo 3S · 11.1 V · 2200 mAh" },
      { label: "Radio", value: "4 Channel" },
      { label: "Propeller", value: "8×4 / 9×4" },
    ],
  },
  // ---- R/C Systems ----
  {
    id: "rc-futaba-16izs",
    name: "Futaba 16IZS — 16-Channel Digital Proportional R/C System",
    category: "R/C Systems",
    image: "/products/16IZS-front.webp",
    tagline: "Now available in India — Futaba's 2-stick 18-channel FASSTest computer system.",
    description:
      "The Futaba 16IZS transmitter is a 16-channel computer system operating on the 2.4 GHz FASSTest protocol. A professional-grade, 2-stick / 18-channel radio for serious RC pilots, competition flyers and demanding scale / aerobatic setups.",
    specs: [
      { label: "Channels", value: "16 (18-channel system)" },
      { label: "Modulation", value: "FASSTest · 2.4 GHz" },
      { label: "Configuration", value: "2-stick" },
      { label: "Class", value: "Computer transmitter" },
      { label: "Availability", value: "Now available in India" },
    ],
  },
  {
    id: "rc-futaba-6kv3s",
    name: "Futaba 6KV3S — 8-Channel Digital Proportional R/C System",
    category: "R/C Systems",
    image: "/products/6KV3.avif",
    tagline: "8-channel Futaba 2.4 GHz T-FHSS / S-FHSS transmitter with R3008SB receiver.",
    description:
      "The Futaba 6KV3S transmitter is an 8-channel digital proportional RC system supplied with an R3008SB 8-channel receiver. A dependable 2-stick 2.4 GHz T-FHSS Air / S-FHSS radio for sport and scale flying.",
    specs: [
      { label: "Channels", value: "8" },
      { label: "Modulation", value: "T-FHSS Air / S-FHSS · 2.4 GHz" },
      { label: "Configuration", value: "2-stick" },
      { label: "Receiver", value: "R3008SB (8-channel, included)" },
      { label: "Availability", value: "Now available in India" },
    ],
  },
  // ---- RC ARF Models (Almost Ready to Fly) ----
  {
    id: "arf-ace",
    name: "Ace RC (ARF)",
    category: "RC ARF Models",
    image: "/products/ACE.jpg",
    tagline: "Almost-Ready-to-Fly RC sport model — pre-assembled by skilled modellers.",
    description:
      "The Ace ARF arrives largely pre-built, letting you get airborne faster. Requires engine, propeller, radio-control set with 4 servos and fuel. Note: the colour scheme of the ARF may vary from the displayed one.",
    specs: [
      { label: "Type", value: "Radio Control ARF" },
      { label: "Radio", value: "4 Channel with 4 Servos" },
      { label: "Powerplant", value: "Glow engine + propeller" },
      { label: "Assembly", value: "Almost Ready to Fly" },
    ],
  },
  {
    id: "arf-boomerang",
    name: "Boomerang RC (ARF)",
    category: "RC ARF Models",
    image: "/products/boomerang-Copy.jpg",
    tagline: "Classic Boomerang trainer / sport model in Almost-Ready-to-Fly form.",
    description:
      "The Boomerang ARF is a versatile sport / trainer airframe pre-assembled by skilled modellers. Requires engine, propeller, radio-control set with 4 servos and fuel. Note: the colour scheme of the ARF may vary from the displayed one.",
    specs: [
      { label: "Type", value: "Radio Control ARF" },
      { label: "Radio", value: "4 Channel with 4 Servos" },
      { label: "Powerplant", value: "Glow engine + propeller" },
      { label: "Assembly", value: "Almost Ready to Fly" },
    ],
  },
  {
    id: "arf-kaiser-mkii",
    name: "Kaiser MK II RC (ARF)",
    category: "RC ARF Models",
    image: "/products/2016_12_Kaiser-MKII-e1481614899983.jpg",
    tagline: "4-channel trainer (high wing) / aerobatic (low wing) — pre-assembled ARF.",
    description:
      "The Kaiser MK II ARF is a 4-channel radio-control trainer (high wing) or aerobatic (low wing) airframe. Compatible with 2.5–4.5 cc (0.15–0.25 cu\") glow engines or a 300–400 W brushless electric setup.",
    specs: [
      { label: "Type", value: "Radio Control ARF" },
      { label: "Wingspan", value: "125 cm" },
      { label: "Cord", value: "21 cm" },
      { label: "Length", value: "96 cm" },
      { label: "Engine (glow)", value: "2.5 – 4.5 cc (0.15 – 0.25 cu\")" },
      { label: "Motor (electric)", value: "300 – 400 W brushless" },
      { label: "Radio", value: "4 Channel" },
    ],
  },
  {
    id: "arf-apple-box-glider",
    name: "RC Glider — Apple Box (ARF)",
    category: "RC ARF Models",
    image: "/products/Apple-Box-scaled.jpg",
    tagline: "Almost-Ready-to-Fly RC glider — pre-assembled by skilled modellers.",
    description:
      "The Apple Box RC glider in ARF form — largely pre-built for a fast trip from box to sky. Ideal for hobbyists after graceful, powered-glider flight without spending weeks on assembly.",
    specs: [
      { label: "Type", value: "Radio Control Glider (ARF)" },
      { label: "Discipline", value: "Powered glider / thermal soaring" },
      { label: "Radio", value: "4 Channel with 4 Servos" },
      { label: "Assembly", value: "Almost Ready to Fly" },
    ],
  },
  {
    id: "arf-swan",
    name: "Swan RC (ARF)",
    category: "RC ARF Models",
    image: "/products/swan-scaled.jpg",
    tagline: "The Swan sport airframe — pre-assembled and ready for the field.",
    description:
      "The Swan ARF arrives pre-assembled by skilled modellers. Requires engine, propeller, radio-control set with 4 servos and fuel. Note: the colour scheme of the ARF may vary from the displayed one.",
    specs: [
      { label: "Type", value: "Radio Control ARF" },
      { label: "Radio", value: "4 Channel with 4 Servos" },
      { label: "Powerplant", value: "Glow engine + propeller" },
      { label: "Assembly", value: "Almost Ready to Fly" },
    ],
  },
  // ---- Control Line Kits ----
  {
    id: "cl-jr-peace-maker",
    name: "\"Jr. Peace Maker\" Control Line Kit",
    category: "Control Line Kits",
    image: "/products/Jr.-Peace-Maker.jpg",
    tagline: "Compact control-line trainer — the classic first CL model.",
    description:
      "The Jr. Peace Maker is a compact control-line model — an approachable first CL build for aeromodellers learning circular flight. Made in India.",
    specs: [
      { label: "Type", value: "Control Line (CL)" },
      { label: "Discipline", value: "Trainer" },
      { label: "Build", value: "Pre-cut wood, scaled drawing" },
      { label: "Skill Level", value: "Beginner" },
      { label: "Origin", value: "Made in India" },
    ],
  },
  {
    id: "cl-sr-peace-maker",
    name: "\"Senior Peace Maker\" Control Line Kit",
    category: "Control Line Kits",
    image: "/products/2016_12_Senior-Peace-Maker-1.jpg",
    tagline: "Control-line trainer / aerobatic model for 2.5–3.2 cc engines.",
    description:
      "The Senior Peace Maker is a control-line trainer and aerobatic model. Kit contains pre-cut wood parts and a scaled drawing for building. Requires assembly, engine, propeller, control-line wire with handle, and fuel. Made in India.",
    specs: [
      { label: "Type", value: "Control Line (CL)" },
      { label: "Discipline", value: "Trainer / Aerobatic" },
      { label: "Wingspan", value: "102 cm" },
      { label: "Length", value: "69 cm" },
      { label: "Engine", value: "2.5 – 3.2 cc" },
      { label: "Build", value: "Pre-cut wood, scaled drawing" },
      { label: "Skill Level", value: "Beginner – Advanced" },
      { label: "Origin", value: "Made in India" },
    ],
  },
  {
    id: "cl-windson-h",
    name: "\"The Windson-H\" Control Line Kit",
    category: "Control Line Kits",
    image: "/products/2016_12_Windson-H.jpg",
    tagline: "Advanced control-line aerobatic model for 3.2–4.5 cc engines.",
    description:
      "The Windson-H is a control-line aerobatic model built for advanced pilots. Kit contains pre-cut wood parts and a scaled drawing for building. Requires assembly, engine, propeller, control-line wire with handle, and fuel. Made in India.",
    specs: [
      { label: "Type", value: "Control Line (CL)" },
      { label: "Discipline", value: "Aerobatic" },
      { label: "Wingspan", value: "106 cm" },
      { label: "Length", value: "68 cm" },
      { label: "Engine", value: "3.2 – 4.5 cc" },
      { label: "Build", value: "Pre-cut wood, scaled drawing" },
      { label: "Skill Level", value: "Advanced" },
      { label: "Origin", value: "Made in India" },
    ],
  },
  // ---- Display Model Kits ----
  {
    id: "display-mig-21",
    name: "MiG-21 Display Model Kit",
    category: "Display Model Kits",
    image: "/products/6-scaled.jpg",
    tagline: "Quick-assemble wooden DIY scale-look display model of the MiG-21.",
    description:
      "A quick-assemble wooden DIY kit with a scale look — the ultimate display model of the iconic MiG-21. Includes laser-cut kit, assembly manual, cyanoacrylate glue and sandpaper. Note: display model only, not fly-worthy, available in kit form only. Made in India.",
    specs: [
      { label: "Type", value: "Display Model Kit (DIY)" },
      { label: "Length", value: "305 mm" },
      { label: "Width", value: "140 mm" },
      { label: "Height", value: "78 mm (approx.)" },
      { label: "Build", value: "Laser-cut wood, quick assemble" },
      { label: "Includes", value: "Laser-cut kit, manual, cyno, sandpaper" },
      { label: "Note", value: "Display only, not fly-worthy" },
      { label: "Origin", value: "Made in India" },
    ],
  },
  {
    id: "display-rafale",
    name: "Rafale Display Model Kit",
    category: "Display Model Kits",
    image: "/products/cd297038-257c-4203-adcf-6cacbe2374e0.jpg",
    tagline: "Quick-assemble wooden DIY scale-look display model of the Rafale.",
    description:
      "A quick-assemble wooden DIY kit with a scale look — a display model of the Dassault Rafale. Includes laser-cut kit, assembly manual, cyanoacrylate glue and sandpaper. Note: display model only, not fly-worthy, available in kit form only. Made in India.",
    specs: [
      { label: "Type", value: "Display Model Kit (DIY)" },
      { label: "Length", value: "266.5 mm" },
      { label: "Width", value: "195 mm" },
      { label: "Height", value: "87.5 mm (approx.)" },
      { label: "Build", value: "Laser-cut wood, quick assemble" },
      { label: "Includes", value: "Laser-cut kit, manual, cyno, sandpaper" },
      { label: "Note", value: "Display only, not fly-worthy" },
      { label: "Origin", value: "Made in India" },
    ],
  },
  {
    id: "display-sukhoi-30-mki",
    name: "Sukhoi Su-30 MKI Display Model Kit",
    category: "Display Model Kits",
    image: "/products/20-scaled.jpg",
    tagline: "Quick-assemble wooden DIY scale-look display model of the Su-30 MKI.",
    description:
      "A quick-assemble wooden DIY kit with a scale look — a display model of the IAF's Sukhoi Su-30 MKI. Includes laser-cut kit, assembly manual, cyanoacrylate glue and sandpaper. Note: display model only, not fly-worthy, available in kit form only. Made in India.",
    specs: [
      { label: "Type", value: "Display Model Kit (DIY)" },
      { label: "Length", value: "274 mm" },
      { label: "Width", value: "180 mm" },
      { label: "Height", value: "77 mm (approx.)" },
      { label: "Build", value: "Laser-cut wood, quick assemble" },
      { label: "Includes", value: "Laser-cut kit, manual, cyno, sandpaper" },
      { label: "Note", value: "Display only, not fly-worthy" },
      { label: "Origin", value: "Made in India" },
    ],
  },
  // ---- Building Accessories ----
  {
    id: "acc-balsa-pack",
    name: "Balsa Sheet Assortment",
    category: "Building Accessories",
    image: IMAGES.cnc,
    tagline: "Graded balsa sheets in mixed thicknesses.",
    description:
      "A curated assortment of contest-grade balsa sheets in common thicknesses — the raw material behind every good build.",
    specs: [
      { label: "Contents", value: "12 sheets, mixed" },
      { label: "Thickness", value: "1.5 / 3 / 5 / 6 mm" },
      { label: "Sheet Size", value: "100 × 900 mm" },
      { label: "Grade", value: "Contest / medium" },
    ],
  },
  {
    id: "acc-covering-film",
    name: "Heat-Shrink Covering Film",
    category: "Building Accessories",
    image: IMAGES.cnc,
    tagline: "Iron-on covering film for a taut, sealed finish.",
    description:
      "Durable heat-shrink covering film that goes on with a standard covering iron for a clean, fuel-proof surface.",
    specs: [
      { label: "Roll Length", value: "2 m" },
      { label: "Width", value: "640 mm" },
      { label: "Application", value: "Iron-on / heat gun" },
      { label: "Finish", value: "Gloss, fuel-proof" },
    ],
  },
  {
    id: "acc-cya-set",
    name: "Cyanoacrylate Adhesive Set",
    category: "Building Accessories",
    image: IMAGES.cnc,
    tagline: "Thin / medium / thick CA with activator.",
    description:
      "A three-viscosity cyanoacrylate set with activator and applicator tips — covers everything from wicking joints to gap-filling.",
    specs: [
      { label: "Contents", value: "3 × CA + activator" },
      { label: "Viscosities", value: "Thin / medium / thick" },
      { label: "Includes", value: "Tips + activator spray" },
      { label: "Use", value: "Balsa, ply, composites" },
    ],
  },
  {
    id: "acc-undercarriage",
    name: "Undercarriage & Wheel Set",
    category: "Building Accessories",
    image: IMAGES.cnc,
    tagline: "Sprung undercarriage with foam wheels.",
    description:
      "A ready-to-fit sprung aluminium undercarriage with lightweight foam wheels and collets — sized for .40-class trainers.",
    specs: [
      { label: "Wheel Dia.", value: "63 mm" },
      { label: "Gear Material", value: "Aluminium alloy" },
      { label: "Axle", value: "4 mm, collets incl." },
      { label: "Fits", value: ".40 – .46 trainers" },
    ],
  },
  {
    id: "acc-diy-glider",
    name: "DIY Beginner Glider Kit",
    category: "Building Accessories",
    image: IMAGES.cnc,
    tagline: "All-in-one starter kit to build your first glider.",
    description:
      "A complete beginner DIY glider kit — pre-cut parts, adhesive, covering and plans in one box, designed to spark a lifelong love of flight.",
    specs: [
      { label: "Wingspan", value: "600 mm" },
      { label: "Contents", value: "Parts + glue + plan" },
      { label: "Tools Needed", value: "Hobby knife only" },
      { label: "Age", value: "10+" },
    ],
  },
  // ---- Defense RPAS & UAS ----
  {
    id: "rpas-trainer-fw",
    name: "Indigenous Fixed-Wing RPAS (Trainer)",
    category: "Defense RPAS & UAS",
    image: IMAGES.hero,
    tagline: "Rugged fixed-wing platform for RPAS training programmes.",
    description:
      "An indigenously designed fixed-wing remotely piloted aircraft built for defence training. Robust composite airframe, forgiving handling, and field-serviceable systems.",
    specs: [
      { label: "Configuration", value: "Fixed-wing, pusher" },
      { label: "Wingspan", value: "2.2 m (class)" },
      { label: "Construction", value: "Glass/carbon composite" },
      { label: "Role", value: "RPAS pilot training" },
      { label: "Origin", value: "Designed & built in India" },
    ],
  },
  {
    id: "rpas-surveillance",
    name: "Long-Endurance Surveillance UAS",
    category: "Defense RPAS & UAS",
    image: IMAGES.hero,
    tagline: "Extended-endurance platform for observation roles.",
    description:
      "A long-endurance unmanned aerial system configured for observation and situational-awareness roles, with modular payload provisioning.",
    specs: [
      { label: "Configuration", value: "Fixed-wing" },
      { label: "Endurance", value: "Extended (mission-set)" },
      { label: "Payload", value: "Modular, EO provision" },
      { label: "Construction", value: "Composite airframe" },
      { label: "Availability", value: "On enquiry" },
    ],
  },
  {
    id: "uas-custom",
    name: "Custom Mission UAS Platform",
    category: "Defense RPAS & UAS",
    image: IMAGES.hero,
    tagline: "Bespoke UAS engineered to your mission spec.",
    description:
      "A ground-up custom unmanned aerial system engineered to defined mission requirements — airframe design, composite fabrication, integration and field support, all in-house.",
    specs: [
      { label: "Configuration", value: "To specification" },
      { label: "Design", value: "In-house CAD" },
      { label: "Fabrication", value: "Vacuum-bagged composite" },
      { label: "Support", value: "Integration + field spares" },
      { label: "Availability", value: "Made to order" },
    ],
  },
  // ---- Distributed UAS ----
  {
    id: "dist-gcs",
    name: "Ground Control Station",
    category: "Distributed UAS",
    image: IMAGES.drone,
    tagline: "Portable GCS for mission planning & control.",
    description:
      "A distributed, ruggedised ground control station for mission planning and live control — supplied and integrated as part of a complete UAS package.",
    specs: [
      { label: "Type", value: "Ground Control Station" },
      { label: "Form Factor", value: "Portable / ruggedised" },
      { label: "Sourcing", value: "Distributed third-party" },
      { label: "Support", value: "Integration incl." },
    ],
  },
  {
    id: "dist-payload-cam",
    name: "EO Payload Camera Module",
    category: "Distributed UAS",
    image: IMAGES.drone,
    tagline: "Gimbal-stabilised electro-optical payload.",
    description:
      "A gimbal-stabilised electro-optical camera payload, matched and integrated to our airframes for clean, steady imagery.",
    specs: [
      { label: "Type", value: "EO camera payload" },
      { label: "Stabilisation", value: "Gimbal (multi-axis)" },
      { label: "Sourcing", value: "Distributed third-party" },
      { label: "Integration", value: "Airframe-matched" },
    ],
  },
  {
    id: "dist-quad",
    name: "Multirotor Platform",
    category: "Distributed UAS",
    image: IMAGES.drone,
    tagline: "Stable quad/hex platform for short-range tasks.",
    description:
      "A distributed multirotor platform for short-range observation and training, supplied with setup and operator familiarisation.",
    specs: [
      { label: "Type", value: "Multirotor (quad/hex)" },
      { label: "Role", value: "Short-range / training" },
      { label: "Sourcing", value: "Distributed third-party" },
      { label: "Support", value: "Setup + familiarisation" },
    ],
  },
  {
    id: "dist-datalink",
    name: "Telemetry & Datalink Kit",
    category: "Distributed UAS",
    image: IMAGES.drone,
    tagline: "Robust telemetry and command datalink set.",
    description:
      "A telemetry and command datalink kit for reliable air-to-ground communication, supplied and configured with our platforms.",
    specs: [
      { label: "Type", value: "Telemetry / datalink" },
      { label: "Link", value: "Air-to-ground" },
      { label: "Sourcing", value: "Distributed third-party" },
      { label: "Config", value: "Pre-paired on delivery" },
    ],
  },
  // ---- Diesel Engines (Sharma Model — Control Line & Free Flight, RC) ----
  {
    id: "sma-diesel-1-5-cl", name: "Sharma Diesel Engine 1.5 cc — Control Line / Free Flight", category: "Diesel Engines",
    image: "/products/de1.gif",
    tagline: "1.5 cc diesel engine for control-line and free-flight models.",
    description: "A compact Sharma diesel engine — ideal for control-line and free-flight aeromodelling. Runs on the classic diesel blend of kerosene, castor oil and ether solvent. Made in India.",
    specs: [
      { label: "Displacement", value: "1.5 cc" },
      { label: "Use", value: "Control Line / Free Flight" },
      { label: "Fuel", value: "Kerosene 40% · Castor 30% · Ether 30%" },
      { label: "Origin", value: "Made in India" },
    ],
  },
  {
    id: "sma-diesel-2-5-cl", name: "Sharma Diesel Engine 2.5 cc — Control Line / Free Flight", category: "Diesel Engines",
    image: "/products/2016_12_Engine-scaled.jpg",
    tagline: "2.5 cc diesel engine for control-line and free-flight models.",
    description: "A dependable Sharma 2.5 cc diesel engine for control-line and free-flight aeromodelling. Runs on the classic diesel blend of kerosene, castor oil and ether solvent. Made in India.",
    specs: [
      { label: "Displacement", value: "2.5 cc" },
      { label: "Weight", value: "182 g" },
      { label: "Prop", value: "8×6 – 9×4" },
      { label: "Fuel", value: "Kerosene 40% · Castor 30% · Ether 30%" },
      { label: "Origin", value: "Made in India" },
    ],
  },
  {
    id: "sma-diesel-3-2-cl", name: "Sharma Diesel Engine 3.2 cc — Control Line / Free Flight", category: "Diesel Engines",
    image: "/products/2016_12_Engine-scaled.jpg",
    tagline: "3.2 cc diesel engine for control-line and free-flight models.",
    description: "A Sharma 3.2 cc diesel engine for control-line and free-flight aeromodelling. Runs on the classic diesel blend of kerosene, castor oil and ether solvent. Made in India.",
    specs: [
      { label: "Displacement", value: "3.2 cc" },
      { label: "Weight", value: "183 g" },
      { label: "Prop", value: "8×6 – 9×6" },
      { label: "Fuel", value: "Kerosene 40% · Castor 30% · Ether 30%" },
      { label: "Origin", value: "Made in India" },
    ],
  },
  {
    id: "sma-diesel-1-5-rc", name: "Sharma Diesel Engine 1.5 cc RC (Metal Carburettor)", category: "Diesel Engines",
    image: "/products/1.5CC-RC-NEW-3.jpg",
    tagline: "1.5 cc radio-controlled diesel engine with metal carburettor.",
    description: "A compact Sharma 1.5 cc RC diesel engine with metal carburettor. Runs on the classic diesel blend of kerosene, castor oil and ether solvent. Made in India.",
    specs: [
      { label: "Displacement", value: "1.5 cc" },
      { label: "Weight", value: "137 g" },
      { label: "Prop", value: "7×6 – 8×4" },
      { label: "Carburettor", value: "Metal" },
      { label: "Fuel", value: "Kerosene 40% · Castor 30% · Ether 30%" },
      { label: "Origin", value: "Made in India" },
    ],
  },
  {
    id: "sma-diesel-2-5-rc", name: "Sharma Diesel Engine 2.5 cc RC", category: "Diesel Engines",
    image: "/products/3.2CC-NEW.jpg",
    tagline: "2.5 cc radio-controlled diesel engine for RC aeromodels.",
    description: "A Sharma 2.5 cc RC diesel engine for radio-control aeromodelling. Runs on the classic diesel blend of kerosene, castor oil and ether solvent. Made in India.",
    specs: [
      { label: "Displacement", value: "2.5 cc" },
      { label: "Weight", value: "194 g" },
      { label: "Prop", value: "8×6 – 9×4" },
      { label: "Fuel", value: "Kerosene 40% · Castor 30% · Ether 30%" },
      { label: "Origin", value: "Made in India" },
    ],
  },
  {
    id: "sma-diesel-3-2-rc", name: "Sharma Diesel Engine 3.2 cc RC (Metal Carburettor)", category: "Diesel Engines",
    image: "/products/3.2CC-NEW.jpg",
    tagline: "3.2 cc radio-controlled diesel engine with metal carburettor.",
    description: "A Sharma 3.2 cc RC diesel engine with metal carburettor. Runs on the classic diesel blend of kerosene, castor oil and ether solvent. Made in India.",
    specs: [
      { label: "Displacement", value: "3.2 cc" },
      { label: "Weight", value: "194 g" },
      { label: "Prop", value: "8×6 – 9×6" },
      { label: "Carburettor", value: "Metal" },
      { label: "Fuel", value: "Kerosene 40% · Castor 30% · Ether 30%" },
      { label: "Origin", value: "Made in India" },
    ],
  },
  // ---- Glow Plug Engines (OS Max) ----
  {
    id: "os-max-046ax-ii", name: "OS Max 0.46 AX II", category: "Glow Plug Engines",
    image: "/products/os-max-46ax-2.jpg",
    tagline: "OS Max 0.46 AX II — 7.5cc glow engine.",
    description: "OS Max 0.46AX (7.5 cc) — a proven Japanese-made two-stroke glow engine widely trusted by sport and aerobatic RC pilots.",
    specs: [
      { label: "Displacement", value: "7.5 cc (0.46 cu in)" },
      { label: "Practical RPM", value: "2,000 – 17,000" },
      { label: "Output", value: "1.63 hp @ 16,000 rpm" },
      { label: "Origin", value: "Made in Japan" },
    ],
  },
  {
    id: "os-max-055ax", name: "OS Max 0.55 AX", category: "Glow Plug Engines",
    image: "/products/OS55-AX.jpg",
    tagline: "OS Max 0.55 AX — 8.93cc high-output glow engine.",
    description: "OS Max 0.55AX (8.93 cc) — a strong mid-large-displacement glow engine suitable for aerobatic and scale RC models.",
    specs: [
      { label: "Displacement", value: "8.93 cc (0.55 cu in)" },
      { label: "Practical RPM", value: "2,000 – 17,000" },
      { label: "Output", value: "1.68 hp @ 16,000 rpm" },
      { label: "Origin", value: "Made in Japan" },
    ],
  },
  {
    id: "os-max-065ax", name: "OS Max 0.65 AX", category: "Glow Plug Engines",
    image: "/products/OS-65AX.jpg",
    tagline: "OS Max 0.65 AX — 10.6cc high-torque glow engine.",
    description: "OS Max 0.65AX (10.6 cc) — a large-class two-stroke glow engine offering strong, reliable output for larger sport and aerobatic models.",
    specs: [
      { label: "Displacement", value: "10.6 cc (0.65 cu in)" },
      { label: "Practical RPM", value: "2,500 – 16,000" },
      { label: "Output", value: "1.73 hp @ 16,000 rpm" },
      { label: "Origin", value: "Made in Japan" },
    ],
  },
  {
    id: "os-max-15-la-silver", name: "OS Max 15 LA Silver", category: "Glow Plug Engines",
    image: "/products/OX-MAX-15-LA-SILVER.jpg",
    tagline: "OS Max 15 LA Silver — compact 2.5cc glow engine with silencer.",
    description: "OS Max 15 LA Silver (model OS 11532) — a compact glow engine supplied with silencer, ideal for smaller sport and trainer models.",
    specs: [
      { label: "Model", value: "OS 11532" },
      { label: "Class", value: "0.15 (2.5 cc approx.)" },
      { label: "Includes", value: "Silencer" },
      { label: "Origin", value: "Made in Japan" },
    ],
  },
  {
    id: "os-max-25-fx-ii", name: "OS Max-25FXII (12662)", category: "Glow Plug Engines",
    image: "/products/25-FX-II.jpg",
    tagline: "OS Max-25FXII glow engine with No.8 plug silencer set.",
    description: "OS Max-25FXII (part 12662) — a classic 0.25-class two-stroke glow engine supplied with No.8 plug silencer set.",
    specs: [
      { label: "Model", value: "OS 12662" },
      { label: "Class", value: "0.25 (4.1 cc approx.)" },
      { label: "Includes", value: "No.8 plug, silencer set" },
      { label: "Origin", value: "Made in Japan" },
    ],
  },
  {
    id: "os-max-95-ax", name: "OS Max 95 AX Engine", category: "Glow Plug Engines",
    image: "/products/OS-MAX-95-AX-1.jpg",
    tagline: "OS Max 95 AX — 15.55cc dual-bearing glow engine for large models.",
    description: "OS Max 95 AX (15.55 cc) — dual ball-bearing engine with high power and long life, suited to large aerobatic and scale models.",
    specs: [
      { label: "Displacement", value: "15.55 cc" },
      { label: "Bearings", value: "Dual ball-bearing" },
      { label: "Best For", value: "Aerobatic & scale models" },
      { label: "Origin", value: "Made in Japan" },
    ],
  },
  {
    id: "os-engine-gt-33", name: "OS Engine GT 33", category: "Glow Plug Engines",
    image: "/products/33.jpg",
    tagline: "OS Engine GT 33 — high-displacement engine for large models.",
    description: "The OS GT 33 — a proven high-displacement engine from OS Japan for large RC aircraft.",
    specs: [
      { label: "Model", value: "OS GT 33" },
      { label: "Class", value: "Large-displacement" },
      { label: "Origin", value: "Made in Japan" },
    ],
  },
  // ---- Petrol / Gas Engines ----
  {
    id: "os-gt120-120cc", name: "OS Max GT120 120cc Petrol Engine", category: "Petrol/Gas Engines",
    image: "/products/OS-GT-120T-1.jpg",
    tagline: "OS GT120 — 120cc horizontally-opposed 2-cylinder petrol engine.",
    description: "The OS Max GT120 is a 2-stroke gasoline 120cc horizontally-opposed 2-cylinder engine, compatible with 100-inch class acro machines and 20 kg-class scale planes. Includes Igniter IG-10, 2× CM-6 spark plugs, propeller washer and 6× M5×50 cap screws. Muffler not included.",
    specs: [
      { label: "Displacement", value: "120 cc" },
      { label: "Configuration", value: "2-stroke, opposed 2-cylinder" },
      { label: "Best For", value: "100\" acro / 20 kg scale planes" },
      { label: "Includes", value: "IG-10 igniter, plugs, hardware" },
      { label: "Muffler", value: "Not included" },
      { label: "Origin", value: "Made in Japan" },
    ],
  },
  {
    id: "os-gt60-60cc", name: "OS Max GT60 60cc Petrol Engine (with Muffler)", category: "Petrol/Gas Engines",
    image: "/products/OS-GT-60-1.jpg",
    tagline: "OS GT60 — 60cc petrol engine supplied with muffler and hardware.",
    description: "The OS Max GT60 is a 60cc gasoline engine compatible with 2.2m class acro planes and 1/4–1/3 scale planes. Supplied with IG-02 igniter, CM-6 Rcexl spark plug, E-6020 silencer/washer, exhaust gasket, propeller, and M5 cap screws.",
    specs: [
      { label: "Displacement", value: "60 cc" },
      { label: "Best For", value: "2.2 m acro / 1/4–1/3 scale" },
      { label: "Includes", value: "IG-02, plug, silencer, hardware, prop" },
      { label: "Origin", value: "Made in Japan" },
    ],
  },
  // ---- Engine Accessories ----
  {
    id: "acc-dle-fuel-pump", name: "DLE Electric Fuel Pump", category: "Engine Accessories",
    image: "/products/DLE-ELECTRIC-FUEL-PUMP-2.jpg",
    tagline: "DLE high-quality electric fuel pump.",
    description: "A DLE high-quality electric fuel pump for reliable field refuelling of large petrol / gas model engines.",
    specs: [ { label: "Brand", value: "DLE" }, { label: "Type", value: "Electric fuel pump" } ],
  },
  {
    id: "acc-engine-mount-15-40", name: "Engine Mount .15 – .40 (ENR India)", category: "Engine Accessories",
    image: "/products/DSC_0123_1574955106262.jpg",
    tagline: "Made-in-India engine mount for .15 – .40 class engines.",
    description: "A robust engine mount for .15 – .40 class model engines, made in India by ENR Model Air Craft, Bangalore.",
    specs: [ { label: "Engine Class", value: ".15 – .40" }, { label: "Origin", value: "Made in India (ENR, Bangalore)" } ],
  },
  {
    id: "acc-engine-mount-40-91", name: "Engine Mount Adjustable .40 – .91 (ENR India)", category: "Engine Accessories",
    image: "/products/DSC_0102_1574954902375.jpg",
    tagline: "Adjustable engine mount for .40 – .91 class engines.",
    description: "An adjustable engine mount for .40 – .91 class engines, made in India by ENR Model Air Craft, Bangalore.",
    specs: [ { label: "Engine Class", value: ".40 – .91" }, { label: "Adjustable", value: "Yes" }, { label: "Origin", value: "Made in India (ENR, Bangalore)" } ],
  },
  {
    id: "acc-exhaust-deflector-blue", name: "Exhaust Deflector — Blue (ENR India)", category: "Engine Accessories",
    image: "/products/download-1-1.jpg",
    tagline: "Coloured exhaust deflector for model engines.",
    description: "A blue exhaust deflector for model engines, made in India by ENR Model Air Craft, Bangalore.",
    specs: [ { label: "Colour", value: "Blue" }, { label: "Origin", value: "Made in India (ENR, Bangalore)" } ],
  },
  {
    id: "acc-exhaust-deflector-red", name: "Exhaust Deflector — Red (ENR India)", category: "Engine Accessories",
    image: "/products/download-3.jpg",
    tagline: "Coloured exhaust deflector for model engines.",
    description: "A red exhaust deflector for model engines, made in India by ENR Model Air Craft, Bangalore.",
    specs: [ { label: "Colour", value: "Red" }, { label: "Origin", value: "Made in India (ENR, Bangalore)" } ],
  },
  {
    id: "acc-exhaust-deflector-yellow", name: "Exhaust Deflector — Yellow (ENR India)", category: "Engine Accessories",
    image: "/products/download-1.jpg",
    tagline: "Coloured exhaust deflector for model engines.",
    description: "A yellow exhaust deflector for model engines, made in India by ENR Model Air Craft, Bangalore.",
    specs: [ { label: "Colour", value: "Yellow" }, { label: "Origin", value: "Made in India (ENR, Bangalore)" } ],
  },
  {
    id: "acc-glow-driver-anderson", name: "Metered Glow Driver 2600 mAh Ni-MH — Anderson 220 V Charger", category: "Engine Accessories",
    image: "/products/DYN1922_A0_X7GQ1NTY.jpg",
    tagline: "Metered glow driver bundled with an Anderson 220 V charger for India.",
    description: "A metered glow driver with a 2600 mAh Sub-C Ni-MH battery, Sure-Lock™ glow plug attachment for hands-free charging, contoured comfort grip finger clip and Anderson 220 V charger suitable for the Indian mains supply.",
    specs: [
      { label: "Battery", value: "2600 mAh Sub-C Ni-MH" },
      { label: "Charger", value: "Anderson 220 V (India)" },
      { label: "Attachment", value: "Sure-Lock™ glow plug" },
    ],
  },
  {
    id: "acc-glow-driver-usb", name: "Metered Glow Driver 2600 mAh Ni-MH — USB Charger", category: "Engine Accessories",
    image: "/products/METERD-GLOW-DRIVER.jpg",
    tagline: "Metered glow driver with USB charger — a compact all-day starter.",
    description: "A metered glow driver with a 2600 mAh Sub-C Ni-MH battery, Sure-Lock™ glow plug attachment, comfort grip finger clip and a convenient USB-style charger. Compact, economical and pocket-sized starting system that fits all glow plugs.",
    specs: [
      { label: "Battery", value: "2600 mAh Sub-C Ni-MH" },
      { label: "Charger", value: "USB style" },
      { label: "Fits", value: "All glow plugs" },
    ],
  },
  {
    id: "acc-os-glow-plug-8", name: "O.S. Glow Plug No. 8", category: "Engine Accessories",
    image: "/products/GLOW-PIUG-NO-8.jpg",
    tagline: "O.S. No. 8 glow plug — made in Japan.",
    description: "The classic O.S. Glow Plug No. 8, made in Japan — a proven glow plug for a wide range of model engines.",
    specs: [ { label: "Brand", value: "O.S." }, { label: "Type", value: "Glow Plug No. 8" }, { label: "Origin", value: "Made in Japan" } ],
  },
  {
    id: "acc-powerpro-12v-starter", name: "PowerPro HD 12 V Starter (HAN162)", category: "Engine Accessories",
    image: "/products/HAN162_A0_ZBFV7CU7.jpg",
    tagline: "High-torque 12 V DC starter — airplanes, cars, boats or helicopters.",
    description: "The PowerPro HD 12 V Starter (Item No. HAN162) is a reliable, high-torque 12 V DC starter that will spin engines up to 1.8 cu in. Mounts easily to the PowerPro PortaSource. Silicone rubber insert included.",
    specs: [
      { label: "Item No.", value: "HAN162" },
      { label: "Voltage", value: "12 V DC" },
      { label: "Max Engine", value: "Up to 1.8 cu in" },
      { label: "Includes", value: "Silicone rubber insert" },
    ],
  },
  {
    id: "acc-silicon-fuel-tube-green", name: "Silicon Fuel Tube — Green (per metre)", category: "Engine Accessories",
    image: "/products/download-11.jpg",
    tagline: "Silicon fuel tubing (green) — made in India.",
    description: "Green silicon fuel tubing — sold per metre. Made in India by ENR Model Aircrafts, Bangalore.",
    specs: [ { label: "Colour", value: "Green" }, { label: "Sold By", value: "Per metre" }, { label: "Origin", value: "Made in India (ENR, Bangalore)" } ],
  },
  {
    id: "acc-silicon-fuel-tube-red", name: "Silicon Fuel Tube — Red (per metre)", category: "Engine Accessories",
    image: "/products/download-10.jpg",
    tagline: "Silicon fuel tubing (red) — made in India.",
    description: "Red silicon fuel tubing — sold per metre. Made in India by ENR Model Aircrafts, Bangalore.",
    specs: [ { label: "Colour", value: "Red" }, { label: "Sold By", value: "Per metre" }, { label: "Origin", value: "Made in India (ENR, Bangalore)" } ],
  },
  // ---- Brushless Motors & ESCs ----
  {
    id: "bl-esc-30a-generic", name: "Brushless ESC 30 A (Generic — SimonK)", category: "Brushless Motors & ESCs",
    image: "/products/30-Amp-ESC.jpg",
    tagline: "SimonK 30 A BLDC ESC — for model aeroplanes and multicopters.",
    description: "A 30 A brushless speed controller (SimonK 30A BLDC ESC) suitable for model aeroplanes and multicopters. 23 g, 45×24×9 mm, 30 A continuous / 40 A burst (5 s), 3 A BEC, 2–3S LiPo, open heat sink for better cooling. Supplied with 3.5 mm & Deans male connectors soldered.",
    specs: [
      { label: "Model", value: "SimonK 30A BLDC" },
      { label: "Current", value: "30 A cont. / 40 A burst" },
      { label: "BEC", value: "3 A" },
      { label: "LiPo", value: "2 – 3S" },
      { label: "Weight / Size", value: "23 g · 45×24×9 mm" },
    ],
  },
  {
    id: "bl-esc-80a-sbec-saker", name: "Brushless ESC 80 A SBEC (Saker)", category: "Brushless Motors & ESCs",
    image: "/products/SAK80ASBEC.jpg",
    tagline: "Saker ESC-80A SBEC — for multicopters and model aero planes.",
    description: "Saker ESC-80A SBEC — 80 A continuous / 90 A max (10 s) brushless speed controller. Input 2–6S LiPo / 5–18S Ni-XX. BEC 5 A @ 5.5 V switching DC-DC. 8 kHz PWM. 67.3 g with cable, 50×32×13 mm.",
    specs: [
      { label: "Brand", value: "Saker" },
      { label: "Current", value: "80 A cont. / 90 A max (10 s)" },
      { label: "Input", value: "2–6S LiPo / 5–18S Ni-XX" },
      { label: "BEC", value: "5 A @ 5.5 V switching" },
      { label: "PWM", value: "8 kHz" },
      { label: "Weight / Size", value: "67.3 g · 50×32×13 mm" },
    ],
  },
  {
    id: "bl-motor-2212-1400", name: "Brushless Motor 2212 · 1400 KV", category: "Brushless Motors & ESCs",
    image: "/products/A2212-1400KV-Golden.jpg",
    tagline: "2212 · 1400 KV brushless motor with 800 g max thrust.",
    description: "A workhorse 2212 · 1400 KV brushless motor delivering up to 800 g of thrust — an ideal upgrade for small RC electric models.",
    specs: [ { label: "Model", value: "2212" }, { label: "KV", value: "1400" }, { label: "Max Thrust", value: "~800 g" } ],
  },
  {
    id: "bl-motor-d2826-1400", name: "Brushless Motor D2826/10 · 1400 KV", category: "Brushless Motors & ESCs",
    image: "/products/brushless-motor-d2826-1400kv-500x500.png",
    tagline: "D2826-10 · 1400 KV high-speed brushless motor.",
    description: "D2826-10 · 1400 KV high-speed brushless motor — 205 W, 18.9 A max, 50 g. Recommended ESC 40 A, props 9×4.7 or 7×4, 2–3S battery, up to ~780 g thrust.",
    specs: [
      { label: "Model", value: "D2826-10" },
      { label: "KV", value: "1400" },
      { label: "Wattage", value: "205 W" },
      { label: "Max Current", value: "18.9 A" },
      { label: "Weight", value: "50 g" },
      { label: "Prop", value: "9×4.7 / 7×4" },
      { label: "Battery", value: "2 – 3S" },
      { label: "Thrust", value: "~780 g" },
      { label: "Recommended ESC", value: "40 A" },
    ],
  },
  {
    id: "bl-esc-40a-hobbywing", name: "ESC 40 A UBEC — HobbyWing Skywalker", category: "Brushless Motors & ESCs",
    image: "/products/ESC-40A-1.jpg",
    tagline: "HobbyWing Skywalker 40 A UBEC ESC for model aeroplanes.",
    description: "HobbyWing Skywalker ESC 40 A UBEC — 40 A continuous / 55 A short (>10 s). 2–3S LiPo or 5–9 Ni-MH / Ni-Cd. BEC 5 V @ 2 A linear. 210,000 rpm max on 2-pole motors. 68×25×8 mm, 35 g (incl. heat sink).",
    specs: [
      { label: "Brand", value: "HobbyWing Skywalker" },
      { label: "Current", value: "40 A cont. / 55 A short" },
      { label: "Input", value: "2–3S LiPo / 5–9 Ni-MH·Cd" },
      { label: "BEC", value: "5 V @ 2 A linear" },
      { label: "Weight / Size", value: "35 g · 68×25×8 mm" },
    ],
  },
  {
    id: "bl-esc-60a-hobbywing", name: "ESC 60 A UBEC — HobbyWing Skywalker", category: "Brushless Motors & ESCs",
    image: "/products/ESC-60-1-1.jpg",
    tagline: "HobbyWing Skywalker 60 A UBEC ESC — 3–6S / Ni-MH support.",
    description: "HobbyWing Skywalker ESC 60 A UBEC — 60 A continuous / 80 A burst (10 s). 3–6S LiPo, 5–18 Ni-MH. Switch-mode BEC 5 A @ 5 V. Throttle refresh 50 – 432 Hz. 77×35×14 mm, 63 g.",
    specs: [
      { label: "Brand", value: "HobbyWing Skywalker" },
      { label: "Current", value: "60 A cont. / 80 A burst" },
      { label: "Input", value: "3–6S LiPo / 5–18 Ni-MH" },
      { label: "BEC", value: "5 A / 5 V switching" },
      { label: "Weight / Size", value: "63 g · 77×35×14 mm" },
    ],
  },
  {
    id: "bl-esc-80a-hobbywing", name: "ESC 80 A UBEC — HobbyWing Skywalker", category: "Brushless Motors & ESCs",
    image: "/products/esc-80-amp-5-1.jpg",
    tagline: "HobbyWing Skywalker 80 A UBEC ESC — 2–6S / Ni-MH support.",
    description: "HobbyWing Skywalker ESC 80 A UBEC — 80 A continuous / 100 A burst (10 s). 2–6S LiPo, 5–18 Ni-MH. Switch-mode BEC 5 A @ 5 V. Throttle refresh 50 – 432 Hz. 86×38×12 mm, 82 g.",
    specs: [
      { label: "Brand", value: "HobbyWing Skywalker" },
      { label: "Current", value: "80 A cont. / 100 A burst" },
      { label: "Input", value: "2–6S LiPo / 5–18 Ni-MH" },
      { label: "BEC", value: "5 A / 5 V switching" },
      { label: "Weight / Size", value: "82 g · 86×38×12 mm" },
    ],
  },
  {
    id: "bl-esc-30a-beatles", name: "ESC 30 A (Beatles)", category: "Brushless Motors & ESCs",
    image: "/products/beatles30.jpg",
    tagline: "30 A brushless ESC — supports high-RPM motors.",
    description: "A 30 A brushless ESC (Beatles) supporting 2–4S LiPo or 5–12 Ni-MH batteries. Features safety thermal overload protection, low-voltage cut-off, auto throttle shutdown on signal loss, and smooth, accurate throttle linearity.",
    specs: [
      { label: "Current", value: "30 A" },
      { label: "Input", value: "2–4S LiPo / 5–12 Ni-MH" },
      { label: "Protections", value: "Thermal, LVC, signal-loss" },
    ],
  },
  {
    id: "bl-esc-40a-beatles", name: "ESC 40 A (Beatles SBEC)", category: "Brushless Motors & ESCs",
    image: "/products/beatles_40a_sbec.jpg",
    tagline: "40 A brushless SBEC ESC — 2–6S LiPo / 5–18S Ni-MH.",
    description: "A 40 A brushless SBEC ESC (Beatles) — 40 A continuous output, 2–6S LiPo or 5–18S Ni-MH input, 52×27×11 mm, 36 g.",
    specs: [
      { label: "Current", value: "40 A cont." },
      { label: "Input", value: "2–6S LiPo / 5–18S Ni-MH" },
      { label: "Weight / Size", value: "36 g · 52×27×11 mm" },
    ],
  },
  {
    id: "bl-sunnysky-x2212-1400", name: "Sunnysky X2212-9 · KV 1400 II Motor", category: "Brushless Motors & ESCs",
    image: "/products/sunnysky-x2212-1400kv-brushless-motor-for-rc-quad-hexa-copter-202_2.jpg",
    tagline: "Sunnysky X2212 · 1400 KV — up to 1200 g of thrust.",
    description: "Sunnysky X2212-1400 KV brushless motor. 56 g, 30 mm length, 27.5 mm diameter, 3 mm shaft. Prop range 8×3.8 to 9×5. Max thrust ~1200 g.",
    specs: [
      { label: "Model", value: "X2212-1400KV II" },
      { label: "KV", value: "1400" },
      { label: "Weight", value: "56 g" },
      { label: "Shaft", value: "3 mm" },
      { label: "Prop Range", value: "8×3.8 – 9×5" },
      { label: "Max Thrust", value: "~1200 g" },
    ],
  },
  {
    id: "bl-sunnysky-x2216-1100", name: "Sunnysky X2216-9 · KV 1100 II Motor", category: "Brushless Motors & ESCs",
    image: "/products/2216-1100KV.jpg",
    tagline: "Sunnysky X2216 · 1100 KV — up to 1520 g of thrust.",
    description: "Sunnysky X2216-1100 KV brushless motor. Stator 22 mm × 16 mm; outer 28 mm × body 32 mm; shaft 3.17 mm; weight 68 g (motor) + 13 g (accessories). Prop range 8×6 – 11×4.7. Max thrust ~1520 g.",
    specs: [
      { label: "Model", value: "X2216-1100KV II" },
      { label: "KV", value: "1100" },
      { label: "Weight", value: "68 g (motor)" },
      { label: "Shaft", value: "3.17 mm" },
      { label: "Prop Range", value: "8×6 – 11×4.7" },
      { label: "Max Thrust", value: "~1520 g" },
    ],
  },
  {
    id: "bl-tmotor-at-40a-4s", name: "T-Motor ESC AT-40A 4S", category: "Brushless Motors & ESCs",
    image: "/products/ESC-40A-4S-T-MOTOR.jpg",
    tagline: "T-Motor AT-40A 4S — original ESC with multi-protection.",
    description: "T-Motor AT-40A 4S — original-manufacture ESC with strong flow resistance, input-voltage protection, low-voltage protection, over-heat protection and throttle-signal loss protection. Ordinary / soft / ultra-soft start modes; fixed-wing and helicopter compatible. Up to 210,000 rpm on 2-pole motors.",
    specs: [ { label: "Brand", value: "T-Motor" }, { label: "Model", value: "AT-40A 4S" }, { label: "Protections", value: "Voltage / LVC / thermal / signal" } ],
  },
  {
    id: "bl-tmotor-velox-v2207", name: "T-Motor Velox V2207 · KV 2550", category: "Brushless Motors & ESCs",
    image: "/products/VELOX-V-2207-MOTOR.jpg",
    tagline: "Velox V2 2207 · 2550 KV — high-power FPV / racing motor.",
    description: "Velox V2 V2207 · KV 2550 (Ice Blue). Ø27.5×31.35 mm, 20 AWG × 150 mm leads, 4 mm shaft. Idle current 1.9 A. Max power (60 s) 545 W. Weight 34.3 g. 12N14P configuration, rated 4S LiPo, peak current (60 s) 38.6 A.",
    specs: [
      { label: "Brand", value: "T-Motor" },
      { label: "Model", value: "Velox V2 V2207" },
      { label: "KV", value: "2550" },
      { label: "Weight", value: "34.3 g" },
      { label: "Rated Voltage", value: "4S LiPo" },
      { label: "Peak Current (60 s)", value: "38.6 A" },
    ],
  },
  // ---- Servo Motors ----
  {
    id: "servo-ace-s1903", name: "ACE RC Standard Servo S1903", category: "Servo Motors",
    image: "/products/Servo-1903.jpg",
    tagline: "ACE RC S1903 — standard analog servo with 4P gears.",
    description: "The ACE RC S1903 standard servo — 3 kg·cm @ 4.8 V / 3.8 kg·cm @ 6 V, 0.19 s @ 4.8 V / 0.15 s @ 6 V, 4P plastic gears, oiless bearing, 47.4 g.",
    specs: [
      { label: "Torque", value: "3.0 / 3.8 kg·cm (4.8 V / 6 V)" },
      { label: "Speed", value: "0.19 / 0.15 s (4.8 V / 6 V)" },
      { label: "Gears", value: "4P" },
      { label: "Bearing", value: "Oiless" },
      { label: "Weight", value: "47.4 g" },
    ],
  },
  {
    id: "servo-futaba-su300", name: "Futaba S-U300 Standard Digital Servo", category: "Servo Motors",
    image: "/products/Servo-With-Accessories.jpg",
    tagline: "Futaba S-U300 — programmable digital servo (S3003 upgrade).",
    description: "Futaba's new S-U300 programmable servo (an upgrade of the popular S3003). Wireless assembly technology gives high vibration resistance and a long lifetime. Up to 4.1 kg·cm torque and down to 0.19 s speed at 6 V. Features a 6-way potentiometer with indirect drive and S.BUS2 programmable parameters.",
    specs: [
      { label: "Torque", value: "Up to 4.1 kg·cm @ 6 V" },
      { label: "Speed", value: "0.19 s @ 6 V" },
      { label: "Type", value: "Digital, programmable" },
      { label: "Bus", value: "S.BUS2" },
    ],
  },
  {
    id: "servo-mg90s", name: "MG 90S 12 g Metal-Gear Servo", category: "Servo Motors",
    image: "/products/MG-90S-Metal-Gear-Servo.jpg",
    tagline: "MG 90S — compact 12 g metal-gear micro servo.",
    description: "MG 90S metal-gear micro servo. Stall torque 1.8 kg·cm @ 4.8 V / 2.2 kg·cm @ 6.0 V. Speed 0.10 s / 60° @ 4.8 V, 0.08 s / 60° @ 6.0 V.",
    specs: [
      { label: "Weight", value: "12 g" },
      { label: "Gears", value: "Metal" },
      { label: "Stall Torque", value: "1.8 / 2.2 kg·cm (4.8 V / 6 V)" },
      { label: "Speed", value: "0.10 / 0.08 s per 60° (4.8 V / 6 V)" },
    ],
  },
  {
    id: "servo-futaba-s3010", name: "Futaba S3010 Standard Analog Servo", category: "Servo Motors",
    image: "/products/FUTABA-S-3010-1.jpg",
    tagline: "Futaba S3010 — standard analog surface servo, high torque.",
    description: "The Futaba S3010 is a standard analog surface servo with high torque output — well suited to a wide range of RC applications.",
    specs: [ { label: "Model", value: "Futaba S3010" }, { label: "Type", value: "Standard analog servo" }, { label: "Notes", value: "High torque" } ],
  },
  {
    id: "servo-futaba-s3003", name: "Futaba S3003 Standard Servo", category: "Servo Motors",
    image: "/products/FUTABA-S-3003.jpg",
    tagline: "Futaba S3003 — the workhorse standard-size servo.",
    description: "The Futaba S3003 is a classic standard-size analog servo, trusted across sport and trainer models for decades.",
    specs: [ { label: "Model", value: "Futaba S3003" }, { label: "Size", value: "Standard" }, { label: "Type", value: "Analog" } ],
  },
  {
    id: "servo-sf-tester-2416", name: "SF Digital Servo + ESC Tester 2416-2", category: "Servo Motors",
    image: "/products/servo-tester.jpg",
    tagline: "SF digital servo + ESC tester — drives up to 4 servos.",
    description: "SF Digital Servo + ESC Tester 2416-2. External power input DC 4.8–12 V (or ESC BEC when testing ESCs). Pulse width: forward 1.5–2 ms, reverse 1–1.5 ms, neutral 1.5 ms. Drives up to 4 servos simultaneously. 44.6×23×29.8 mm, 20.6 g. Made in Taiwan.",
    specs: [
      { label: "Power In", value: "DC 4.8 – 12 V" },
      { label: "Servos", value: "Up to 4 simultaneously" },
      { label: "Weight / Size", value: "20.6 g · 44.6×23×29.8 mm" },
      { label: "Origin", value: "Made in Taiwan" },
    ],
  },
  // ---- R/C Systems — additional Futaba transmitters ----
  {
    id: "rc-futaba-12k", name: "Futaba 12K — 14-Channel Digital Proportional R/C System", category: "R/C Systems",
    image: "/products/12k.avif",
    tagline: "Futaba 12K — 14-channel 2.4 GHz T-FHSS Air computer transmitter.",
    description: "The Futaba 12K is a 14-channel digital proportional RC system. 2-stick, 14-channel, T-FHSS Air 2.4 GHz — now available in India.",
    specs: [
      { label: "Channels", value: "14" },
      { label: "Modulation", value: "T-FHSS Air · 2.4 GHz" },
      { label: "Configuration", value: "2-stick" },
      { label: "Availability", value: "Now available in India" },
    ],
  },
  {
    id: "rc-futaba-6l-sport", name: "Futaba 6L Sport — 6-Channel Digital Proportional R/C System", category: "R/C Systems",
    image: "/products/6L.avif",
    tagline: "Futaba 6L Sport — 6-channel 2.4 GHz T-FHSS Air transmitter.",
    description: "The Futaba 6L Sport is a 6-channel digital proportional RC system. 2-stick, 6-channel, T-FHSS Air 2.4 GHz — a dependable entry-level Futaba radio.",
    specs: [
      { label: "Channels", value: "6" },
      { label: "Modulation", value: "T-FHSS Air · 2.4 GHz" },
      { label: "Configuration", value: "2-stick" },
    ],
  },
  // ---- Balsa & Depron ----
  {
    id: "balsa-1mm", name: "B.S.1 Balsa Sheet 1 mm (Pack of 2)", category: "Balsa & Depron",
    image: "/products/balsa.jpg",
    tagline: "Imported balsa sheet — 1 mm × 100 mm × 930 mm (pack of 2).",
    description: "Imported balsa sheet supplied in a pack of 2. Ideal for planking, sheeting and general model-building.",
    specs: [ { label: "Thickness", value: "1 mm" }, { label: "Size", value: "100 × 930 mm" }, { label: "Pack", value: "2 sheets" } ],
  },
  {
    id: "balsa-1-5mm", name: "B.S.1.5 Balsa Sheet 1.5 mm (Pack of 2)", category: "Balsa & Depron",
    image: "/products/balsa.jpg",
    tagline: "Imported balsa sheet — 1.5 mm × 100 mm × 930 mm (pack of 2).",
    description: "Imported balsa sheet supplied in a pack of 2. Great for skinning and detail work.",
    specs: [ { label: "Thickness", value: "1.5 mm" }, { label: "Size", value: "100 × 930 mm" }, { label: "Pack", value: "2 sheets" } ],
  },
  {
    id: "balsa-2mm", name: "B.S.2 Balsa Sheet 2 mm (Pack of 2)", category: "Balsa & Depron",
    image: "/products/balsa.jpg",
    tagline: "Imported balsa sheet — 2 mm × 100 mm × 1000 mm (pack of 2).",
    description: "Imported balsa sheet supplied in a pack of 2.",
    specs: [ { label: "Thickness", value: "2 mm" }, { label: "Size", value: "100 × 1000 mm" }, { label: "Pack", value: "2 sheets" } ],
  },
  {
    id: "balsa-2-5mm", name: "B.S.2.5 Balsa Sheet 2.5 mm (Pack of 2)", category: "Balsa & Depron",
    image: "/products/balsa.jpg",
    tagline: "Imported balsa sheet — 2.5 mm × 100 mm × 1000 mm (pack of 2).",
    description: "Imported balsa sheet supplied in a pack of 2.",
    specs: [ { label: "Thickness", value: "2.5 mm" }, { label: "Size", value: "100 × 1000 mm" }, { label: "Pack", value: "2 sheets" } ],
  },
  {
    id: "balsa-3mm", name: "B.S.3 Balsa Sheet 3 mm (Pack of 2)", category: "Balsa & Depron",
    image: "/products/balsa.jpg",
    tagline: "Imported balsa sheet — 3 mm × 100 mm × 1000 mm (pack of 2).",
    description: "Imported balsa sheet supplied in a pack of 2.",
    specs: [ { label: "Thickness", value: "3 mm" }, { label: "Size", value: "100 × 1000 mm" }, { label: "Pack", value: "2 sheets" } ],
  },
  {
    id: "balsa-4mm", name: "B.S.4 Balsa Sheet 4 mm (Pack of 2)", category: "Balsa & Depron",
    image: "/products/balsa.jpg",
    tagline: "Imported balsa sheet — 4 mm × 100 mm × 930 mm (pack of 2).",
    description: "Imported balsa sheet supplied in a pack of 2.",
    specs: [ { label: "Thickness", value: "4 mm" }, { label: "Size", value: "100 × 930 mm" }, { label: "Pack", value: "2 sheets" } ],
  },
  {
    id: "balsa-6mm", name: "B.S.6 Balsa Sheet 6 mm", category: "Balsa & Depron",
    image: "/products/balsa.jpg",
    tagline: "Imported balsa sheet — 6 mm × 100 mm × 1000 mm (single sheet).",
    description: "Imported balsa sheet supplied as a single sheet.",
    specs: [ { label: "Thickness", value: "6 mm" }, { label: "Size", value: "100 × 1000 mm" }, { label: "Pack", value: "1 sheet" } ],
  },
  {
    id: "balsa-8mm", name: "B.S.8 Balsa Sheet 8 mm", category: "Balsa & Depron",
    image: "/products/balsa.jpg",
    tagline: "Imported balsa sheet — 8 mm × 100 mm × 1000 mm (single sheet).",
    description: "Imported balsa sheet supplied as a single sheet.",
    specs: [ { label: "Thickness", value: "8 mm" }, { label: "Size", value: "100 × 1000 mm" }, { label: "Pack", value: "1 sheet" } ],
  },
  {
    id: "balsa-10mm", name: "B.S.10 Balsa Sheet 10 mm", category: "Balsa & Depron",
    image: "/products/balsa.jpg",
    tagline: "Imported balsa sheet — 10 mm × 100 mm × 1000 mm (single sheet).",
    description: "Imported balsa sheet supplied as a single sheet.",
    specs: [ { label: "Thickness", value: "10 mm" }, { label: "Size", value: "100 × 1000 mm" }, { label: "Pack", value: "1 sheet" } ],
  },
  {
    id: "balsa-12mm", name: "B.S.12 Balsa Sheet 12 mm", category: "Balsa & Depron",
    image: "/products/balsa.jpg",
    tagline: "Imported balsa sheet — 12 mm × 100 mm × 1000 mm (single sheet).",
    description: "Imported balsa sheet supplied as a single sheet.",
    specs: [ { label: "Thickness", value: "12 mm" }, { label: "Size", value: "100 × 1000 mm" }, { label: "Pack", value: "1 sheet" } ],
  },
  {
    id: "depron-3mm", name: "Depron Sheet 3 mm (Pack of 4 · 100 × 30 cm)", category: "Balsa & Depron",
    image: "/products/3mm1-scaled.jpg",
    tagline: "Depron sheets (non-laminated) for model making — 3 mm.",
    description: "Depron sheets (non-laminated) for model making — lightweight, homogeneous material. Includes 4 nos. 3 mm-thick Depron sheets of 100 × 30 cm. Approximate combined weight ~165 g.",
    specs: [ { label: "Thickness", value: "3 mm" }, { label: "Size", value: "100 × 30 cm" }, { label: "Pack", value: "4 sheets" }, { label: "Weight (4 sheets)", value: "~165 g" } ],
  },
  {
    id: "depron-8mm", name: "Depron Sheet 8 mm (Pack of 5 · 100 × 50 cm)", category: "Balsa & Depron",
    image: "/products/6mm-scaled.jpg",
    tagline: "Depron sheets (non-laminated) for model making — 8 mm.",
    description: "Depron sheets (non-laminated) for model making — lightweight, homogeneous material. Includes 5 nos. 8 mm-thick Depron sheets of 100 × 50 cm.",
    specs: [ { label: "Thickness", value: "8 mm" }, { label: "Size", value: "100 × 50 cm" }, { label: "Pack", value: "5 sheets" } ],
  },
  // ---- Flight Simulators ----
  {
    id: "sim-realflight-evolution", name: "RealFlight Evolution RC Flight Simulator with InterLink DX (RFL2000)", category: "Flight Simulators",
    image: "/products/IMG_8481-002.jpg",
    tagline: "RealFlight Evolution — realistic RC flight simulator with InterLink DX.",
    description: "The RealFlight Evolution RC Flight Simulator (Item No. RFL2000) ships with an InterLink DX controller — the industry-standard training tool for learning RC flight safely at home.",
    specs: [
      { label: "Model", value: "RealFlight Evolution · RFL2000" },
      { label: "Controller", value: "InterLink DX (included)" },
      { label: "Best For", value: "Home training / practice" },
    ],
  },
  // ---- 3D Aerobatic Models ----
  {
    id: "3d-wicked-33-kit-blue", name: "33\" Wicked Slick Pro — Kit Only (Blue & Yellow)", category: "3D Aerobatic Models",
    image: "/products/WICKED-SLICKED-PRO-3-1.webp",
    tagline: "Kit-only version of the elegant 33\" Wicked Slick Pro (Blue & Yellow).",
    description: "The 33\" Wicked Slick Pro kit — enhanced 3D aerobatic performance, robust EPP foam construction with an eye-catching colour scheme, carbon-reinforced wing / fuselage / suspension braces, and a generous hardware package.",
    specs: [ { label: "Type", value: "3D Aerobatic RC — Kit Only" }, { label: "Wingspan", value: "33 in (838 mm)" }, { label: "Scheme", value: "Blue & Yellow" }, { label: "Construction", value: "EPP foam, carbon reinforced" } ],
  },
  {
    id: "3d-wicked-33-kit-red", name: "33\" Wicked Slick Pro — Kit Only (Red & Yellow)", category: "3D Aerobatic Models",
    image: "/products/37-WICKED-SLICK-PRO-2-1.webp",
    tagline: "Kit-only version of the 33\" Wicked Slick Pro (Red & Yellow).",
    description: "The 33\" Wicked Slick Pro kit in Red & Yellow trim — enhanced 3D aerobatic performance, EPP foam construction, carbon-reinforced structural braces, generous hardware package.",
    specs: [ { label: "Type", value: "3D Aerobatic RC — Kit Only" }, { label: "Wingspan", value: "33 in (838 mm)" }, { label: "Scheme", value: "Red & Yellow" }, { label: "Construction", value: "EPP foam, carbon reinforced" } ],
  },
  {
    id: "3d-laser-37-kit-aj", name: "37\" Laser 230Z — Kit Only (AJ Scheme)", category: "3D Aerobatic Models",
    image: "/products/991e64_d47d32e150f24b5a8eabfa00a96b894emv2.webp",
    tagline: "37\" Laser 230Z — AJ Aircraft livery, kit only.",
    description: "The 37\" Laser 230Z in AJ Aircraft livery — a collaboration between AJ Aircraft and pilot Mr. Andrew Jesky. Built with larger controls, superior foam, and premium hardware.",
    specs: [ { label: "Type", value: "3D Aerobatic RC — Kit Only" }, { label: "Wingspan", value: "37 in (940 mm)" }, { label: "Livery", value: "AJ Aircraft" } ],
  },
  {
    id: "3d-laser-37-pnp-aj", name: "37\" Laser 230Z — PNP Combo (AJ Scheme)", category: "3D Aerobatic Models",
    image: "/products/37-LASER-COMBO-11.webp",
    tagline: "37\" Laser 230Z PNP combo in AJ Aircraft livery.",
    description: "The 37\" Laser 230Z in AJ Aircraft livery — supplied as a PNP (Plug-N-Play) combo, ready for your radio and battery.",
    specs: [ { label: "Type", value: "3D Aerobatic RC — PNP Combo" }, { label: "Wingspan", value: "37 in (940 mm)" }, { label: "Livery", value: "AJ Aircraft" } ],
  },
  {
    id: "3d-wicked-37-kit-blue", name: "37\" Wicked Slick Pro — Kit Only (Blue & Yellow)", category: "3D Aerobatic Models",
    image: "/products/WICKED-SLICKED-PRO-3-1.webp",
    tagline: "37\" Wicked Slick Pro kit — Blue & Yellow.",
    description: "The larger 37\" Wicked Slick Pro kit — enhanced 3D aerobatic performance, EPP foam construction, carbon-reinforced structural braces, generous hardware package.",
    specs: [ { label: "Type", value: "3D Aerobatic RC — Kit Only" }, { label: "Wingspan", value: "37 in (940 mm)" }, { label: "Scheme", value: "Blue & Yellow" } ],
  },
  {
    id: "3d-wicked-37-kit-red", name: "37\" Wicked Slick Pro — Kit Only (Red & Yellow)", category: "3D Aerobatic Models",
    image: "/products/37-WICKED-SLICK-PRO-2-1.webp",
    tagline: "37\" Wicked Slick Pro kit — Red & Yellow.",
    description: "The 37\" Wicked Slick Pro kit in Red & Yellow trim — an elegant 3D aerobatic airframe with EPP construction and carbon reinforcement.",
    specs: [ { label: "Type", value: "3D Aerobatic RC — Kit Only" }, { label: "Wingspan", value: "37 in (940 mm)" }, { label: "Scheme", value: "Red & Yellow" } ],
  },
  {
    id: "3d-wicked-37-pnp-blue", name: "37\" Wicked Slick Pro — PNP Combo (Blue & Yellow)", category: "3D Aerobatic Models",
    image: "/products/WICKED-SLICK-PRO-BLUE-1-1.webp",
    tagline: "37\" Wicked Slick Pro PNP combo — Blue & Yellow.",
    description: "The 37\" Wicked Slick Pro in PNP-combo form — our most famous 3D airframe, ready to plug in your radio and battery.",
    specs: [ { label: "Type", value: "3D Aerobatic RC — PNP Combo" }, { label: "Wingspan", value: "37 in (940 mm)" }, { label: "Scheme", value: "Blue & Yellow" } ],
  },
  {
    id: "3d-wicked-37-pnp-red", name: "37\" Wicked Slick Pro — PNP Combo (Red & Yellow)", category: "3D Aerobatic Models",
    image: "/products/Wicked-Slick-Red-Yellow-1.webp",
    tagline: "37\" Wicked Slick Pro PNP combo — Red & Yellow.",
    description: "The 37\" Wicked Slick Pro in PNP-combo form (Red & Yellow) — pre-fitted electronics for a fast field-day setup.",
    specs: [ { label: "Type", value: "3D Aerobatic RC — PNP Combo" }, { label: "Wingspan", value: "37 in (940 mm)" }, { label: "Scheme", value: "Red & Yellow" } ],
  },
  // ---- Seagull ARF Models ----
  {
    id: "seagull-arising-star-sea03n", name: "Arising Star — Seagull Models SEA03N", category: "Seagull ARF Models",
    image: "/products/ARISING-STAR-40-46-SEA03-p1.jpg",
    tagline: "Seagull Arising Star — a proven trainer ARF from Seagull Models Vietnam.",
    description: "The Seagull Arising Star (SEA03N) — a well-known trainer ARF from Seagull Models, Vietnam.",
    specs: [ { label: "Brand", value: "Seagull Models" }, { label: "Model", value: "SEA03N" }, { label: "Type", value: "ARF Trainer" } ],
  },
  {
    id: "seagull-boomerang-sea27n", name: "Boomerang — Seagull Models SEA27N", category: "Seagull ARF Models",
    image: "/products/Boomerang.jpg",
    tagline: "Seagull Boomerang — a classic trainer / sport ARF.",
    description: "The Seagull Boomerang (SEA27N) — a classic trainer / sport ARF by Seagull Models.",
    specs: [ { label: "Brand", value: "Seagull Models" }, { label: "Model", value: "SEA27N" }, { label: "Type", value: "Sport / Trainer ARF" } ],
  },
  {
    id: "seagull-christen-eagle-sea104", name: "Christen Eagle II — Seagull Models SEA104", category: "Seagull ARF Models",
    image: "/products/CHRISTIAN-EAGLE-1.jpg",
    tagline: "Seagull Christen Eagle II — a striking scale biplane ARF.",
    description: "The Seagull Christen Eagle II (SEA104) — a beautifully finished scale biplane ARF by Seagull Models.",
    specs: [ { label: "Brand", value: "Seagull Models" }, { label: "Model", value: "SEA104" }, { label: "Type", value: "Scale Biplane ARF" } ],
  },
  {
    id: "seagull-piper-cub-sea74", name: "Piper Cub — Seagull Models SEA74", category: "Seagull ARF Models",
    image: "/products/PIPER-CUB-1.jpg",
    tagline: "Seagull Piper Cub — an evergreen scale ARF classic.",
    description: "The Seagull Piper Cub (SEA74) — the classic yellow scale trainer, beautifully rendered in ARF form.",
    specs: [ { label: "Brand", value: "Seagull Models" }, { label: "Model", value: "SEA74" }, { label: "Type", value: "Scale ARF" } ],
  },
  {
    id: "seagull-pt19-sea11", name: "PT-19 Fairchild — Seagull Models SEA11", category: "Seagull ARF Models",
    image: "/products/PT-19-FAIRCHILD.jpg",
    tagline: "Seagull PT-19 Fairchild — a scale WWII-era trainer ARF.",
    description: "The Seagull PT-19 Fairchild (SEA11) — a scale ARF of the iconic WWII-era Fairchild PT-19 primary trainer.",
    specs: [ { label: "Brand", value: "Seagull Models" }, { label: "Model", value: "SEA11" }, { label: "Type", value: "Scale ARF" } ],
  },
  {
    id: "seagull-lw-trainer-sea10n", name: "Seagull Low Wing Trainer — SEA10N", category: "Seagull ARF Models",
    image: "/products/SEAGULL-LW-1.jpg",
    tagline: "Seagull Low-Wing Trainer — a step up from high-wing trainers.",
    description: "The Seagull Low Wing Trainer (SEA10N) — a proven low-wing ARF trainer for pilots stepping up in performance.",
    specs: [ { label: "Brand", value: "Seagull Models" }, { label: "Model", value: "SEA10N" }, { label: "Type", value: "Low-wing Trainer ARF" } ],
  },
  {
    id: "seagull-spacewalker-ii-sea61n", name: "Space Walker II \"Revolution + C11n\" — Seagull Models SEA61N", category: "Seagull ARF Models",
    image: "/products/SAPACE-WALKER-1.jpg",
    tagline: "Space Walker II \"Revolution + C11n\" — Seagull Models scale ARF.",
    description: "The Seagull Space Walker II \"Revolution + C11n\" (SEA61N) — a beautifully finished scale ARF.",
    specs: [ { label: "Brand", value: "Seagull Models" }, { label: "Model", value: "SEA61N" }, { label: "Type", value: "Scale ARF" } ],
  },
  {
    id: "seagull-spacewalker-ii-sea19", name: "Space Walker II — Seagull Models SEA19", category: "Seagull ARF Models",
    image: "/products/SPACEWALKER-II-46-SEA19-p1.jpg",
    tagline: "Space Walker II — Seagull Models scale ARF.",
    description: "The Seagull Space Walker II (SEA19) — a classic scale ARF.",
    specs: [ { label: "Brand", value: "Seagull Models" }, { label: "Model", value: "SEA19" }, { label: "Type", value: "Scale ARF" } ],
  },
  {
    id: "seagull-xtreme-decathlon-sea83b", name: "Xtreme Decathlon — Seagull Models SEA83B", category: "Seagull ARF Models",
    image: "/products/XTREME-DECATHLON-1.jpg",
    tagline: "Xtreme Decathlon — an aerobatic scale ARF by Seagull Models.",
    description: "The Seagull Xtreme Decathlon (SEA83B) — an aerobatic scale ARF that flies with equal grace on the fun-fly line and pattern circuit.",
    specs: [ { label: "Brand", value: "Seagull Models" }, { label: "Model", value: "SEA83B" }, { label: "Type", value: "Aerobatic Scale ARF" } ],
  },
  // ---- FMS PNP Models ----
  {
    id: "fms-zero-a6m5-1100", name: "FMS 1100 mm (43.3\") Zero A6M5 PNP", category: "FMS PNP Models",
    image: "/products/1-5.jpg",
    tagline: "FMS Mitsubishi Zero A6M5 — 1100 mm scale warbird in PNP form.",
    description: "The FMS 1100 mm (43.3\") Zero A6M5 in PNP (Plug-N-Play) form — a beautifully finished scale WWII warbird.",
    specs: [ { label: "Brand", value: "FMS" }, { label: "Wingspan", value: "1100 mm (43.3 in)" }, { label: "Type", value: "Scale Warbird PNP" } ],
  },
  {
    id: "fms-easy-trainer-1280", name: "FMS 1280 mm (50.4\") Easy Trainer 1280 PNP", category: "FMS PNP Models",
    image: "/products/4-4.jpg",
    tagline: "FMS Easy Trainer 1280 — a forgiving 1280 mm PNP trainer.",
    description: "The FMS 1280 mm (50.4\") Easy Trainer 1280 in PNP form — a forgiving trainer airframe ideal for pilots learning fundamentals.",
    specs: [ { label: "Brand", value: "FMS" }, { label: "Wingspan", value: "1280 mm (50.4 in)" }, { label: "Type", value: "PNP Trainer" } ],
  },
  {
    id: "fms-cobra-p39-980", name: "FMS 980 mm (38.6\") \"Cobra II\" P-39 Racing High-Speed PNP", category: "FMS PNP Models",
    image: "/products/4-5.jpg",
    tagline: "FMS P-39 \"Cobra II\" — 980 mm high-speed racing PNP.",
    description: "The FMS 980 mm (38.6\") \"Cobra II\" P-39 Racing High-Speed PNP — a fast racing scale model for experienced pilots.",
    specs: [ { label: "Brand", value: "FMS" }, { label: "Wingspan", value: "980 mm (38.6 in)" }, { label: "Type", value: "Racing / High-Speed PNP" } ],
  },
  // ---- Chuck & Catapult Gliders ----
  {
    id: "chuck-gladiator", name: "Catapult Glider Gladiator", category: "Chuck & Catapult Gliders",
    image: "/products/glaidiator-3-scaled.jpg",
    tagline: "Catapult glider Gladiator — a quick-build free-flight favourite.",
    description: "The Gladiator catapult glider. Wingspan 50.1 cm, length 40 cm. Kit contains pre-cut parts, scaled drawing, building instructions, sandpaper, glue and modelling clay (for balancing).",
    specs: [ { label: "Type", value: "Catapult Glider" }, { label: "Wingspan", value: "50.1 cm" }, { label: "Length", value: "40 cm" }, { label: "Includes", value: "Pre-cut parts, plan, glue, clay" } ],
  },
  {
    id: "chuck-angry-bird", name: "Chuck Glider Angry Bird", category: "Chuck & Catapult Gliders",
    image: "/products/angry-bird-scaled.jpg",
    tagline: "Chuck glider Angry Bird — a fun quick-build for kids and beginners.",
    description: "The Angry Bird chuck glider — a fun, quick-build free-flight model for kids and first-time aeromodellers.",
    specs: [ { label: "Type", value: "Chuck / Hand-launched Glider" }, { label: "Skill Level", value: "Beginner" } ],
  },
  {
    id: "chuck-pigeon", name: "Chuck Glider Pigeon", category: "Chuck & Catapult Gliders",
    image: "/products/Piegon-copy.jpg",
    tagline: "Chuck glider Pigeon — smooth, buoyant hand-launched glider.",
    description: "The Pigeon chuck glider — a smooth, buoyant hand-launched free-flight model.",
    specs: [ { label: "Type", value: "Chuck / Hand-launched Glider" }, { label: "Skill Level", value: "Beginner" } ],
  },
  {
    id: "chuck-seagull", name: "Chuck Glider Seagull", category: "Chuck & Catapult Gliders",
    image: "/products/SEAGULL.jpg",
    tagline: "Chuck glider Seagull — an elegant hand-launched free-flight model.",
    description: "The Seagull chuck glider — an elegant hand-launched free-flight model that flies with grace.",
    specs: [ { label: "Type", value: "Chuck / Hand-launched Glider" }, { label: "Skill Level", value: "Beginner" } ],
  },
  {
    id: "chuck-hunter", name: "Hunter Chuck Glider", category: "Chuck & Catapult Gliders",
    image: "/products/2016_12_2-1024x683-1.jpg",
    tagline: "Hunter chuck glider — a quick-build free-flight favourite.",
    description: "The Hunter chuck glider — a straightforward, quick-build free-flight model.",
    specs: [ { label: "Type", value: "Chuck / Hand-launched Glider" }, { label: "Skill Level", value: "Beginner" } ],
  },
  // ---- Control Line ARF Models (folded into Control Line Kits by category badge) ----
  {
    id: "cl-arf-sr-peace-maker", name: "\"Senior Peace Maker\" Control Line ARF", category: "Control Line Kits",
    image: "/products/2016_12_Senior-Peace-Maker.jpg",
    tagline: "Senior Peace Maker in ARF form — pre-assembled control-line trainer / aerobatic.",
    description: "The Senior Peace Maker in Almost-Ready-to-Fly form — a control-line trainer / aerobatic model with 102 cm wingspan and 69 cm length, for 2.5 – 3.2 cc engines. Requires engine, propeller, control-line wire with handle and fuel. Made in India.",
    specs: [
      { label: "Type", value: "Control Line ARF" },
      { label: "Wingspan", value: "102 cm" },
      { label: "Length", value: "69 cm" },
      { label: "Engine", value: "2.5 – 3.2 cc" },
      { label: "Skill Level", value: "Beginner – Advanced" },
      { label: "Origin", value: "Made in India" },
    ],
  },
  {
    id: "cl-arf-windson-h", name: "\"Windson-H\" Control Line ARF", category: "Control Line Kits",
    image: "/products/2016_12_Windson-H.jpg",
    tagline: "Windson-H in Almost-Ready-to-Fly form — advanced control-line aerobatic.",
    description: "The Windson-H in Almost-Ready-to-Fly form — an advanced control-line aerobatic model.",
    specs: [
      { label: "Type", value: "Control Line ARF" },
      { label: "Discipline", value: "Aerobatic" },
      { label: "Skill Level", value: "Advanced" },
      { label: "Origin", value: "Made in India" },
    ],
  },
  // ---- Propellers (Aeromodel India brand) ----
  { id: "prop-nitro-7x4", name: "Propeller 7×4 (Nitro/Gas — Glass-Filled Nylon)", category: "Propellers", image: "/products/7X4.jpg", tagline: "7×4 glass-filled nylon propeller — for 1 cc engines.", description: "Glass-filled nylon propeller — 7\" × 4\" for 1 cc engines. Made in India.", specs: [ { label: "Size", value: "7 × 4 in" }, { label: "Engine", value: "1 cc" }, { label: "Material", value: "Glass-filled nylon" }, { label: "Origin", value: "Made in India" } ] },
  { id: "prop-nitro-8x4", name: "Propeller 8×4 (Nitro/Gas — Glass-Filled Nylon)", category: "Propellers", image: "/products/8X4.jpg", tagline: "8×4 glass-filled nylon propeller — 1.5 cc diesel / 2.5 cc glow.", description: "Glass-filled nylon propeller — 8\" × 4\" for 1.5 cc diesel & 2.5 cc glow engines. Made in India.", specs: [ { label: "Size", value: "8 × 4 in" }, { label: "Engine", value: "1.5 cc diesel / 2.5 cc glow" }, { label: "Material", value: "Glass-filled nylon" }, { label: "Origin", value: "Made in India" } ] },
  { id: "prop-nitro-8x6", name: "Propeller 8×6 (Nitro/Gas — Glass-Filled Nylon)", category: "Propellers", image: "/products/8X6.jpg", tagline: "8×6 glass-filled nylon propeller — 2.5 – 3.5 cc engines.", description: "Glass-filled nylon propeller — 8\" × 6\" for 2.5 – 3.5 cc engines. Made in India.", specs: [ { label: "Size", value: "8 × 6 in" }, { label: "Engine", value: "2.5 – 3.5 cc" }, { label: "Material", value: "Glass-filled nylon" }, { label: "Origin", value: "Made in India" } ] },
  { id: "prop-nitro-8x8", name: "Propeller 8×8 (Nitro/Gas — Glass-Filled Nylon)", category: "Propellers", image: "/products/8X8.jpg", tagline: "8×8 glass-filled nylon propeller — 5 cc engines.", description: "Glass-filled nylon propeller — 8\" × 8\" for 5 cc engines. Made in India.", specs: [ { label: "Size", value: "8 × 8 in" }, { label: "Engine", value: "5 cc" }, { label: "Material", value: "Glass-filled nylon" }, { label: "Origin", value: "Made in India" } ] },
  { id: "prop-nitro-9x4", name: "Propeller 9×4 (Nitro/Gas — Glass-Filled Nylon)", category: "Propellers", image: "/products/9X4.jpg", tagline: "9×4 glass-filled nylon propeller — 2.5 – 4.5 cc engines.", description: "Glass-filled nylon propeller — 9\" × 4\" for 2.5 – 4.5 cc engines. Made in India.", specs: [ { label: "Size", value: "9 × 4 in" }, { label: "Engine", value: "2.5 – 4.5 cc" }, { label: "Material", value: "Glass-filled nylon" }, { label: "Origin", value: "Made in India" } ] },
  { id: "prop-nitro-9x6", name: "Propeller 9×6 (Nitro/Gas — Glass-Filled Nylon)", category: "Propellers", image: "/products/9X6.jpg", tagline: "9×6 glass-filled nylon propeller — 3.2 – 4.5 cc engines.", description: "Glass-filled nylon propeller — 9\" × 6\" for 3.2 – 4.5 cc engines. Made in India.", specs: [ { label: "Size", value: "9 × 6 in" }, { label: "Engine", value: "3.2 – 4.5 cc" }, { label: "Material", value: "Glass-filled nylon" }, { label: "Origin", value: "Made in India" } ] },
  { id: "prop-nitro-1025x6", name: "Propeller 10.25×6 (Nitro/Gas — Glass-Filled Nylon)", category: "Propellers", image: "/products/10.25X6.jpg", tagline: "10.25×6 propeller — 6 – 7.5 cc engines.", description: "Glass-filled nylon propeller — 10.25\" × 6\" for 6 – 7.5 cc (0.40 – 0.46 cu in) engines. Made in India.", specs: [ { label: "Size", value: "10.25 × 6 in" }, { label: "Engine", value: "6 – 7.5 cc" }, { label: "Material", value: "Glass-filled nylon" }, { label: "Origin", value: "Made in India" } ] },
  { id: "prop-nitro-12x6", name: "Propeller 12×6 (Nitro/Gas — Glass-Filled Nylon)", category: "Propellers", image: "/products/12X6.jpg", tagline: "12×6 glass-filled nylon propeller — 8 – 10 cc engines.", description: "Glass-filled nylon propeller — 12\" × 6\" for 8 – 10 cc engines. Made in India.", specs: [ { label: "Size", value: "12 × 6 in" }, { label: "Engine", value: "8 – 10 cc" }, { label: "Material", value: "Glass-filled nylon" }, { label: "Origin", value: "Made in India" } ] },
  { id: "prop-e-6x4", name: "6×4 Grey E Propeller", category: "Propellers", image: "/products/8X4-2.jpg", tagline: "6×4 grey electric propeller.", description: "6×4 Grey E Propeller — a compact electric propeller for smaller electric RC models.", specs: [ { label: "Size", value: "6 × 4 in" }, { label: "Type", value: "Electric prop" } ] },
  { id: "prop-e-8x4", name: "8×4 Grey E Propeller", category: "Propellers", image: "/products/8X4-2.jpg", tagline: "8×4 grey electric propeller.", description: "8×4 Grey E Propeller — a versatile electric propeller for park-flyers and small RC models.", specs: [ { label: "Size", value: "8 × 4 in" }, { label: "Type", value: "Electric prop" } ] },
  { id: "prop-e-8x6", name: "8×6 Grey E Propeller (Gemfan · Pack of 2)", category: "Propellers", image: "/products/8X6-1.jpg", tagline: "8×6 grey electric propeller — Gemfan pack of 2.", description: "8×6 Grey E Propeller by Gemfan — supplied as a pack of 2.", specs: [ { label: "Size", value: "8 × 6 in" }, { label: "Brand", value: "Gemfan" }, { label: "Pack", value: "2 pcs" } ] },
  { id: "prop-e-9x6", name: "9×6 Grey E Propeller (Gemfan · Pack of 2)", category: "Propellers", image: "/products/9X6-3.jpg", tagline: "9×6 grey electric propeller — Gemfan pack of 2.", description: "9×6 Grey E Propeller by Gemfan — supplied as a pack of 2.", specs: [ { label: "Size", value: "9 × 6 in" }, { label: "Brand", value: "Gemfan" }, { label: "Pack", value: "2 pcs" } ] },
  { id: "prop-e-10x5", name: "10×5 Grey E Propeller (Gemfan · Pack of 2)", category: "Propellers", image: "/products/10X5.jpg", tagline: "10×5 grey electric propeller — Gemfan pack of 2.", description: "10×5 Grey E Propeller by Gemfan — supplied as a pack of 2.", specs: [ { label: "Size", value: "10 × 5 in" }, { label: "Brand", value: "Gemfan" }, { label: "Pack", value: "2 pcs" } ] },
  { id: "prop-e-11x55", name: "11×5.5 Grey E Propeller", category: "Propellers", image: "/products/11X5.5.jpg", tagline: "11×5.5 grey electric propeller — pack of 1.", description: "11×5.5 Grey E Propeller — supplied as a single piece.", specs: [ { label: "Size", value: "11 × 5.5 in" }, { label: "Pack", value: "1 pc" } ] },
  { id: "prop-e-12x6", name: "12×6 Grey E Propeller (Gemfan)", category: "Propellers", image: "/products/12X6-1.jpg", tagline: "12×6 grey electric propeller — Gemfan, pack of 1.", description: "12×6 Grey E Propeller (Gemfan) — supplied as a single piece.", specs: [ { label: "Size", value: "12 × 6 in" }, { label: "Brand", value: "Gemfan" }, { label: "Pack", value: "1 pc" } ] },
  { id: "prop-e-13x65", name: "13×6.5 Grey E Propeller (Gemfan)", category: "Propellers", image: "/products/12X6-1.jpg", tagline: "13×6.5 grey electric propeller — Gemfan, pack of 1.", description: "13×6.5 Grey E Propeller (Gemfan) — supplied as a single piece.", specs: [ { label: "Size", value: "13 × 6.5 in" }, { label: "Brand", value: "Gemfan" }, { label: "Pack", value: "1 pc" } ] },
  { id: "mas-classic-18x8", name: "Classic 18×8 Propeller (Master Air Screw)", category: "Propellers", image: "/products/18-X-8-Classic-1.jpg", tagline: "MAS Classic 18×8 — robust WWI/WWII-look propeller.", description: "MAS Classic 18×8 — robust propeller for glow engines from 1.2 cc to 2.11 cc; scale look for WWI/WWII model aircraft. Glass-fibre reinforced composite.", specs: [ { label: "Series", value: "Classic" }, { label: "Size", value: "18 × 8 in" }, { label: "Weight", value: "144.9 g" }, { label: "Material", value: "Glass-fibre composite" } ] },
  { id: "mas-electric-7x4", name: "Electric Only 7×4 Propeller (Master Air Screw)", category: "Propellers", image: "/products/7-X-4-E.jpg", tagline: "MAS Electric Only 7×4 — undercambered blades.", description: "MAS Electric Only 7×4 — dedicated electric-motor propeller with wide, thin under-cambered blades. Glass-fibre reinforced composite.", specs: [ { label: "Series", value: "Electric Only" }, { label: "Size", value: "7 × 4 in" }, { label: "Weight", value: "7.4 g" }, { label: "Material", value: "Glass-fibre composite" } ] },
  { id: "mas-electric-8x4", name: "Electric Only 8×4 Propeller (Master Air Screw)", category: "Propellers", image: "/products/8-X-4E.jpg", tagline: "MAS Electric Only 8×4 — undercambered blades.", description: "MAS Electric Only 8×4 — dedicated electric-motor propeller. Glass-fibre reinforced composite.", specs: [ { label: "Series", value: "Electric Only" }, { label: "Size", value: "8 × 4 in" }, { label: "Weight", value: "10.5 g" }, { label: "Material", value: "Glass-fibre composite" } ] },
  { id: "mas-electric-9x4", name: "Electric Only 9×4 Propeller (Master Air Screw)", category: "Propellers", image: "/products/9-X-4E.jpg", tagline: "MAS Electric Only 9×4 — undercambered blades.", description: "MAS Electric Only 9×4 — dedicated electric-motor propeller. Glass-fibre reinforced composite.", specs: [ { label: "Series", value: "Electric Only" }, { label: "Size", value: "9 × 4 in" }, { label: "Weight", value: "13.6 g" }, { label: "Material", value: "Glass-fibre composite" } ] },
  { id: "mas-electric-10x6", name: "Electric Only 10×6 Propeller (Master Air Screw)", category: "Propellers", image: "/products/10-X-6E.jpg", tagline: "MAS Electric Only 10×6 — undercambered blades.", description: "MAS Electric Only 10×6 — dedicated electric-motor propeller. Glass-fibre reinforced composite.", specs: [ { label: "Series", value: "Electric Only" }, { label: "Size", value: "10 × 6 in" }, { label: "Weight", value: "16.2 g" }, { label: "Material", value: "Glass-fibre composite" } ] },
  { id: "mas-gf-11x6", name: "GF Series 11×6 Propeller (Master Air Screw)", category: "Propellers", image: "/products/11-X-6-GF.jpg", tagline: "MAS GF Series 11×6 — sport / high-performance.", description: "MAS GF Series 11×6 — designed for sport flying and high-performance R/C airplanes with electric motors or glow engines. Glass-fibre reinforced composite.", specs: [ { label: "Series", value: "GF" }, { label: "Size", value: "11 × 6 in" }, { label: "Weight", value: "26.1 g" }, { label: "Material", value: "Glass-fibre composite" } ] },
  { id: "mas-k-14x4", name: "K Series 14×4 Propeller (Master Air Screw)", category: "Propellers", image: "/products/14-X-4K.jpg", tagline: "MAS K Series 14×4 — larger glow / electric conversion models.", description: "MAS K Series 14×4 — designed for larger 2- and 4-stroke glow engines and electric-conversion models. Glass-fibre reinforced composite.", specs: [ { label: "Series", value: "K" }, { label: "Size", value: "14 × 4 in" }, { label: "Weight", value: "58.1 g" }, { label: "Material", value: "Glass-fibre composite" } ] },
  { id: "mas-k-14x8", name: "K Series 14×8 Propeller (Master Air Screw)", category: "Propellers", image: "/products/14-X-8-K.jpg", tagline: "MAS K Series 14×8 — larger glow / electric.", description: "MAS K Series 14×8 — designed for larger 2- and 4-stroke glow engines and electric-conversion models. Glass-fibre reinforced composite.", specs: [ { label: "Series", value: "K" }, { label: "Size", value: "14 × 8 in" }, { label: "Weight", value: "58.1 g" }, { label: "Material", value: "Glass-fibre composite" } ] },
  { id: "mas-k-15x8", name: "K Series 15×8 Propeller (Master Air Screw)", category: "Propellers", image: "/products/14-X-8-K.jpg", tagline: "MAS K Series 15×8 — for larger models.", description: "MAS K Series 15×8 — for larger 2- and 4-stroke glow engines and electric-conversion models. Glass-fibre reinforced composite.", specs: [ { label: "Series", value: "K" }, { label: "Size", value: "15 × 8 in" }, { label: "Weight", value: "68 g" }, { label: "Material", value: "Glass-fibre composite" } ] },
  { id: "mas-k-16x8", name: "K Series 16×8 Propeller (Master Air Screw)", category: "Propellers", image: "/products/16-X-8K.jpg", tagline: "MAS K Series 16×8 — factory balanced.", description: "MAS K Series 16×8 — factory balanced propeller for larger glow and electric models. Glass-fibre reinforced composite.", specs: [ { label: "Series", value: "K" }, { label: "Size", value: "16 × 8 in" }, { label: "Weight", value: "87.9 g" }, { label: "Material", value: "Glass-fibre composite" } ] },
  { id: "spinner-38mm", name: "38 mm Spinner", category: "Propellers", image: "/products/SPINNER.webp", tagline: "38 mm lightweight plastic spinner.", description: "Lightweight plastic spinner — 38 mm diameter, hub 5–6 mm. Includes cone + backplate.", specs: [ { label: "Diameter", value: "38 mm" }, { label: "Hub", value: "5 – 6 mm" }, { label: "Includes", value: "Cone + backplate" } ] },
  { id: "spinner-50mm", name: "50 mm Spinner", category: "Propellers", image: "/products/SPINNER.webp", tagline: "50 mm lightweight plastic spinner.", description: "Lightweight plastic spinner — 50 mm diameter, hub 5–6 mm. Includes cone + backplate.", specs: [ { label: "Diameter", value: "50 mm" }, { label: "Hub", value: "5 – 6 mm" }, { label: "Includes", value: "Cone + backplate" } ] },
  { id: "spinner-57mm", name: "57 mm Spinner", category: "Propellers", image: "/products/57mm.jpg", tagline: "57 mm precision-machined spinner.", description: "Lightweight spinner (57 mm) — precisely machined with high-quality aluminium and plastic. Includes cone + backplate.", specs: [ { label: "Diameter", value: "57 mm" }, { label: "Material", value: "Aluminium + plastic" }, { label: "Includes", value: "Cone + backplate" } ] },
  { id: "spinner-67mm", name: "67 mm Spinner", category: "Propellers", image: "/products/SPINNER.webp", tagline: "67 mm lightweight plastic spinner.", description: "Lightweight plastic spinner — 67 mm diameter, hub 5–6 mm. Includes cone + backplate.", specs: [ { label: "Diameter", value: "67 mm" }, { label: "Hub", value: "5 – 6 mm" }, { label: "Includes", value: "Cone + backplate" } ] },


];

// ---------------- Distribution / Partner Brands ----------------
export const PARTNER_HEADING =
  "Manufacturing Our Own, and Bringing the World's Best to India";

export const PARTNER_BODY =
  "Beyond our own manufactured products, we proudly distribute high-quality UAS-related products from reputed Indian and foreign brands — including RC products, engines, and accessories — to fulfil the diverse needs of Indian aeromodelling enthusiasts.";

export const PARTNER_BRANDS = [
  {
    id: "rc",
    icon: "Radio",
    title: "Third-Party RC Products",
    blurb:
      "Transmitters, receivers, servos and ready-to-fly models from trusted Indian and international RC brands.",
  },
  {
    id: "engines",
    icon: "Cog",
    title: "Distributed Engines",
    blurb:
      "A curated selection of imported and Indian model engines that complement our own manufactured line.",
  },
  {
    id: "accessories",
    icon: "Package",
    title: "Distributed Accessories",
    blurb:
      "Batteries, chargers, field equipment and spares — everything to keep enthusiasts flying.",
  },
];
